/* eslint-disable no-case-declarations */
/* global jQuery, $, PDFLib, fontkit, dat */

/*                                                                                                

          _____                    _____                    _____                    _____                    _____                   _______         
         /\    \                  /\    \                  /\    \                  /\    \                  /\    \                 /::\    \        
        /::\____\                /::\    \                /::\    \                /::\    \                /::\____\               /::::\    \       
       /::::|   |               /::::\    \              /::::\    \              /::::\    \              /:::/    /              /::::::\    \      
      /:::::|   |              /::::::\    \            /::::::\    \            /::::::\    \            /:::/    /              /::::::::\    \     
     /::::::|   |             /:::/\:::\    \          /:::/\:::\    \          /:::/\:::\    \          /:::/    /              /:::/~~\:::\    \    
    /:::/|::|   |            /:::/__\:::\    \        /:::/__\:::\    \        /:::/__\:::\    \        /:::/____/              /:::/    \:::\    \   
   /:::/ |::|   |           /::::\   \:::\    \      /::::\   \:::\    \      /::::\   \:::\    \       |::|    |              /:::/    / \:::\    \  
  /:::/  |::|___|______    /::::::\   \:::\    \    /::::::\   \:::\    \    /::::::\   \:::\    \      |::|    |     _____   /:::/____/   \:::\____\ 
 /:::/   |::::::::\    \  /:::/\:::\   \:::\    \  /:::/\:::\   \:::\____\  /:::/\:::\   \:::\    \     |::|    |    /\    \ |:::|    |     |:::|    |
/:::/    |:::::::::\____\/:::/  \:::\   \:::\____\/:::/  \:::\   \:::|    |/:::/__\:::\   \:::\____\    |::|    |   /::\____\|:::|____|     |:::|    |
\::/    / ~~~~~/:::/    /\::/    \:::\  /:::/    /\::/   |::::\  /:::|____|\:::\   \:::\   \::/    /    |::|    |  /:::/    / \:::\    \   /:::/    / 
 \/____/      /:::/    /  \/____/ \:::\/:::/    /  \/____|:::::\/:::/    /  \:::\   \:::\   \/____/     |::|    | /:::/    /   \:::\    \ /:::/    /  
             /:::/    /            \::::::/    /         |:::::::::/    /    \:::\   \:::\    \         |::|____|/:::/    /     \:::\    /:::/    /   
            /:::/    /              \::::/    /          |::|\::::/    /      \:::\   \:::\____\        |:::::::::::/    /       \:::\__/:::/    /    
           /:::/    /               /:::/    /           |::| \::/____/        \:::\   \::/    /        \::::::::::/____/         \::::::::/    /     
          /:::/    /               /:::/    /            |::|  ~|               \:::\   \/____/          ~~~~~~~~~~                \::::::/    /      
         /:::/    /               /:::/    /             |::|   |                \:::\    \                                         \::::/    /       
        /:::/    /               /:::/    /              \::|   |                 \:::\____\                                         \::/____/        
        \::/    /                \::/    /                \:|   |                  \::/    /                                          ~~              
         \/____/                  \/____/                  \|___|                   \/____/                                                           
                                                                                                                                                      


   ____  _      _                        _        _______         __                      _           _    
  / __ \| |    | |                      | |      |__   __|       / _|                    | |         | |   
 | |  | | | ___| | _____  __ _ _ __   __| |_ __     | |_ __ ___ | |_ _   _ _ __ ___   ___| |__  _   _| | __
 | |  | | |/ _ \ |/ / __|/ _` | '_ \ / _` | '__|    | | '__/ _ \|  _| | | | '_ ` _ \ / __| '_ \| | | | |/ /
 | |__| | |  __/   <\__ \ (_| | | | | (_| | |       | | | | (_) | | | |_| | | | | | | (__| | | | |_| |   < 
  \____/|_|\___|_|\_\___/\__,_|_| |_|\__,_|_|       |_|_|  \___/|_|  \__, |_| |_| |_|\___|_| |_|\__,_|_|\_\
  _____            _        __      __                   _            __/ |                                
 |  __ \          | |       \ \    / /                  (_)          |___/                                 
 | |__) |_ ___   _| | ___    \ \  / /__  _ __ ___  _ __  _ _ __                                            
 |  ___/ _` \ \ / / |/ _ \    \ \/ / _ \| '__/ _ \| '_ \| | '_ \                                           
 | |  | (_| |\ V /| | (_) |    \  / (_) | | | (_) | | | | | | | |                                          
 |_|   \__,_| \_/ |_|\___/      \/ \___/|_|  \___/|_| |_|_|_| |_|                                          
 
*/

// Created by Marevo (Pavlo Voronin based on Oleksandr Trofymchuk's configurator)
// Welcome to our custom script!

// REMEMBER:
// Theft is wrong not because some ancient text says, 'Thou shalt not steal.'
// It's always bad, robber :)

"use strict";
import $ from "jquery";
import * as THREE from "three";
import "../core/model-viewer.marevo";

// import * as GeometryUtils from 'three/addons/utils/GeometryUtils.js';
import { TextGeometry } from "three/addons/geometries/TextGeometry.js";
import { FontLoader } from "three/addons/loaders/FontLoader.js";
import { computeMorphedAttributes } from "three/addons/utils/BufferGeometryUtils.js";

// const { PDFDocument, StandardFonts, rgb } = PDFLib;

// import { updateRangeBackgroundAndLabel } from './app.js';

//#region PUBLIC VALUES
import {
  BACKGROUND_COLOR,
  ENVIRONMENT_MAP,
  ENVIRONMENT_MAP_INTENSITY,
  MODEL_CENTER_POSITION,
  MODEL_PATHS,
  MORPH_DATA,
  MORPH_DATA_SI,
  pdfImg,
  SHADOW_TRANSPARENCY,
  state,
  WALL_OFFSETS,
} from "./settings";

import { interfaceComponent } from "../components/Interface/interface";
import {
  animateScale,
  bloomPass,
  camera,
  canvas,
  create3DScene,
  dirLight,
  frontLight,
  leftLight,
  rightLight,
  fxaaPass,
  getMobileOperatingSystem,
  IMPORTED_MODELS,
  outputPass,
  renderer,
  saoPass,
  scene,
  updateBloomSettings,
  updateEnvMap,
  // params_Bloom,
  updateRenderSize,
} from "./3d-scene";
import {
  getCorners,
  initLouver,
  listenerChange,
  stepForColumn,
} from "./customFunctions/customFunctions";
import { initSubSystem } from "./customFunctions/initiSubSystem";
import {
  initStateFromUrl,
  listenerChangeForUrl,
} from "./customFunctions/paramsURL";
import {
  makeSpanBySide,
  setAllHotspotsVisibility,
  setSpansHeaters,
} from "./customFunctions/subSystemHeaters";
import {
  makeSpanBySideScreen,
  setAllHotspotsVisibilityScreen,
  setSpansScreen,
} from "./customFunctions/subSystemScreen";
import { initRaycast } from "./raycast";
import { summaryPagePortalComponent } from '../components/summary/summary-page/summary-page-portal/summaryPagePortal';
import { updateTextParam } from "../components/Interface/interfaceItems/interfaceGroup/interfaceGroupInputs/interfaceGroupInputs";

const DEBUG_MODE_VALUES = false;
export let modelForExport = null;

const sceneProperties = {
  BACKGROUND_COLOR: BACKGROUND_COLOR,
  MODEL_PATHS: MODEL_PATHS,
  MODEL_CENTER_POSITION: MODEL_CENTER_POSITION,
  SHADOW_TRANSPARENCY: SHADOW_TRANSPARENCY,
  ENVIRONMENT_MAP: ENVIRONMENT_MAP,
  ENVIRONMENT_MAP_INTENSITY: ENVIRONMENT_MAP_INTENSITY,
};

let delayForWriteURL = false;
let parametersKey = "config";
let parametersValue = "";
let loaded = false;
let paramsLoaded = false;
let isFirstStart = true;
let init = true;

let tblInfo;
let tblInfoItemQr;
let tblInfoItemSharing;
let tblInfoItemLoupe;

let modelViewer;
let qrcode;
let qrScaned = 0;

export let theModel;

let isAutoRotate = false;
const autoRotateSpeed = 0.05;

// MORPHS & SHADER

let isWorldposVertexShaderEnabled = true;
let morphs = [];
let globalMorphs = [];

var threejs_font_helvetiker_regular;

//#endregion

//#region WIX

var isWIX = false;
var wix_api_ACCESS_TOKEN = "YOUR_ACCESS_TOKEN";
var wix_contactForm_Text = "";
var wix_contactForm_name = "test";
var wix_contactForm_email = "at@marevo.vision";
var wix_contactForm_message = "Hello WIX!";

// eslint-disable-next-line no-unused-vars
async function wix_contactForm() {
  // eslint-disable-next-line no-undef
  e.preventDefault();

  try {
    const response = await fetch(
      "https://www.wixapis.com/forms/v1/submissions",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + wix_api_ACCESS_TOKEN,
        },
        body: JSON.stringify({
          fields: {
            wix_contactForm_name,
            wix_contactForm_email,
            wix_contactForm_message,
          },
        }),
      }
    );

    const result = await response.json();
    if (response.ok) {
      console.log("Form submitted successfully!");
    } else {
      console.log(`Error: ${result.message}`);
    }
  } catch (error) {
    console.error("Error:", error);
  }
}

//#endregion

var isRedirectionProject = false;

function setRedirectionProjectSettings(value) {
  isRedirectionProject = value;

  if (!value) {
    $("#wixOverlay").removeClass("active");
    $("#wixOverlay").hide();
    return;
  }

  $("#wixOverlay").addClass("active");
  $("#wixOverlay").show();

  $("#wixContent").on("click", function () {
    // OpenARorQR();
    PergolaOpenARorQR()
  });

  $("#js-wixBack").on("click", function () {
    window.open(
      "https://www.everydaypatio.com/pergola-configurator" +
      "?config=" +
      GetURLWithParameters("", true),
      "_self"
    );
  });
}

//! #region START APP

loadThreeJSFonts();
// Start();

//#endregion

//#region INITIALIZATION

export async function Start() {
  blockURLWriter = true;

  const startCallback = async () => {
    if (loaded) return;
    loaded = true;

    console.log("Scene loaded, starting settings...");
    await StartSettings();

    $("#js-loader").css("display", "none");
    summaryPagePortalComponent('#content');
  };

  // Now pass the defined callback
  create3DScene(sceneProperties, startCallback);
}

export const clones = [];

export async function toggleBackWall(toggle) {
  const wallBackGroup = GetGroup("wall_back");

  wallBackGroup.children.forEach((group) => {
    group.traverse((object) => {
      if (object.isMesh) {
        object.visible = toggle;
      }
    });
  });
}

export async function toggleLeftWall(toggle) {
  const wallBackGroup = GetGroup("wall_L");

  wallBackGroup.children.forEach((group) => {
    group.traverse((object) => {
      if (object.isMesh) {
        object.visible = toggle;
      }
    });
  });
}

export async function toggleRightWall(toggle) {
  const wallRGroup = GetGroup("wall_R");
  wallRGroup.children.forEach((child) => {
    child.traverse((object) => {
      if (object.isMesh) {
        object.visible = toggle;
      }
    });
  });
}

export function toggleLoad(toggle) {
  toggle
    ? $("#app").addClass("app-loader")
    : $("#app").removeClass("app-loader");
}

export async function getSize(model) {
  const box = new THREE.Box3().setFromObject(model);
  const size = box.getSize(new THREE.Vector3());
  console.log(size);
}

async function StartSettings() {
  theModel = IMPORTED_MODELS[0];
  // console.log("🚀 ~ theModel:", theModel);
  InitMorphModel(theModel);
  getSize(theModel);

  PrepareAR();
  paramsLoaded = true;
  initRaycast();

  CreatePergola(theModel);

  theModel.scale.set(0, 0, 0);
  theModel.visible = true;
  animateScale(theModel);

  isFirstStart = false;

  if (
    getMobileOperatingSystem() == "Android" ||
    getMobileOperatingSystem() == "iOS"
  ) {
    CheckQRMobile();
  }

  // initLouver(GetMesh("header"), theModel);

  modelForExport = theModel;

  theModel.traverse((object) => {
    if (object.isMesh && object.name === "louver_X") {
      object.visible = false;
    }
  });

  toggleLoad(false);

  //UI ADD
  interfaceComponent($("#content"));

  //#region HOTSPOT INIT
  const qtyLeft = Math.floor(40 / stepForColumn) + 1;

  makeSpanBySide("left", qtyLeft);
  makeSpanBySide("right", qtyLeft);
  makeSpanBySide("bottom", qtyLeft);
  makeSpanBySide("top", qtyLeft);

  makeSpanBySideScreen("left", qtyLeft);
  makeSpanBySideScreen("right", qtyLeft);
  makeSpanBySideScreen("bottom", qtyLeft);
  makeSpanBySideScreen("top", qtyLeft);

  setSpansScreen();
  setSpansHeaters();

  setAllHotspotsVisibility(false);
  setAllHotspotsVisibilityScreen(false);
  //#endregion

  initSubSystem();
  initRaycast();

  // listenerChangeForUrl();
}

//#endregion

//#region MESH / MATERIAL utils

export function GetMesh(name, model = theModel) {
  var object = null;
  model?.traverse((o) => {
    if (o.isMesh) {
      if (name == o.name) {
        object = o;
      }
    }
  });

  return object;
}

export function GetGroup(name, model = theModel) {
  var group = null;
  model.traverse((o) => {
    if (o.isGroup) {
      if (name == o.name) {
        group = o;
      }
    }
  });

  return group;
}

// eslint-disable-next-line no-unused-vars
function CloneMesh(name, model = theModel) {
  const originalMesh = GetMesh(name, model);
  if (originalMesh) {
    const clonedMesh = originalMesh.clone();
    return clonedMesh;
  } else {
    console.warn(`Mesh with name ${name} not found.`);
    return null;
  }
}

// eslint-disable-next-line no-unused-vars
function CloneGroup(name, model = theModel) {
  const originalGroup = GetGroup(name, model);
  if (originalGroup) {
    const clonedGroup = originalGroup.clone();
    return clonedGroup;
  } else {
    console.warn(`Group with name ${name} not found.`);
    return null;
  }
}

// eslint-disable-next-line no-unused-vars
function RemoveMesh(mesh) {
  if (mesh && mesh.parent) {
    mesh.parent.remove(mesh);
  } else {
    console.warn("Mesh not found or it has no parent.");
  }
}

// eslint-disable-next-line no-unused-vars
function RemoveGroup(group) {
  if (group && group.parent) {
    group.parent.remove(group);
  } else {
    console.warn("Group not found or it has no parent.");
  }
}

// eslint-disable-next-line no-unused-vars
function GetMaterial(name, model = theModel) {
  var material = null;
  model.traverse((o) => {
    if (o.isMaterial) {
      if (name == o.material.name) {
        material = o.material;
      }
    }
  });

  return material;
}

function GetMaterialFromScene(name) {
  var material = null;
  scene.traverse((o) => {
    if (o.material) {
      if (name == o.material.name) {
        material = o.material;
      }
    }
  });

  return material;
}

// eslint-disable-next-line no-unused-vars
function setMaterialProperty(materialName, value, propery = "metalness") {
  const materialObject = GetMaterialFromScene(materialName);
  if (materialObject == null) {
    console.error(`ERROR: Material ${materialName} is not found !`);
    return;
  }
  // eslint-disable-next-line no-prototype-builtins
  if (!materialObject.hasOwnProperty(propery)) {
    console.error(
      `ERROR: Material ${materialName} has no property ${propery} !`
    );
    return;
  }

  materialObject[propery] = value;
  console.log(`${propery} for material ${materialName} was set up to ${value}`);
}

// eslint-disable-next-line no-unused-vars
export function ChangeMaterialTilling(materialName, x, y) {
  var materialObject = GetMaterialFromScene(materialName);

  if (materialObject == null) {
    return;
  }

  if (materialObject.map != null) {
    materialObject.map.repeat.set(x, y);
  }

  if (materialObject.normalMap != null) {
    materialObject.normalMap.repeat.set(x, y);
  }

  if (materialObject.roughnessMap != null) {
    materialObject.roughnessMap.repeat.set(x, y);
  }

  if (materialObject.metalnessMap != null) {
    materialObject.metalnessMap.repeat.set(x, y);
  }

  if (materialObject.aoMap != null) {
    materialObject.aoMap.repeat.set(x, y);
  }
}

// eslint-disable-next-line no-unused-vars
export function ChangeMaterialOffset(materialName, x, y) {
  var materialObject = GetMaterialFromScene(materialName);

  if (materialObject == null) {
    return;
  }

  if (materialObject.map != null) {
    materialObject.map.offset.set(x, y);
  }

  if (materialObject.normalMap != null) {
    materialObject.normalMap.offset.set(x, y);
  }

  if (materialObject.roughnessMap != null) {
    materialObject.roughnessMap.offset.set(x, y);
  }

  if (materialObject.metalnessMap != null) {
    materialObject.metalnessMap.offset.set(x, y);
  }

  if (materialObject.aoMap != null) {
    materialObject.aoMap.offset.set(x, y);
  }
}

// eslint-disable-next-line no-unused-vars
function setVisibility(model, value, meshArray = [], isInclude = false) {
  if (model) {
    if (value == undefined && value == null) {
      return;
    }

    if (meshArray.length === 0) {
      model.visible = value;
      return;
    }

    for (let i = 0; i < meshArray.length; i++) {
      model.traverse((o) => {
        if (o.name == meshArray[i]) {
          o.visible = value;
        }

        if (isInclude) {
          if (o.name.includes(meshArray[i])) {
            o.visible = value;
          }
        }
      });
    }
  }
}

// eslint-disable-next-line no-unused-vars
function setMaterialColor(materialName, color) {
  const materialObject = GetMaterialFromScene(materialName);
  if (materialObject == null) {
    return;
  }
  materialObject.color.set(color);
  materialObject.needsUpdate = true;
}

const textureLoader = new THREE.TextureLoader();
textureLoader.setCrossOrigin("anonymous");
const textureCache = {};
const texturePool = {};

function setTexture(id, path, material, materialProp, tilling) {
  if (material == null) {
    return;
  }
  if (materialProp == null) {
    return;
  }

  const value = texturePool[id.toLowerCase()];
  if (value != null) {
    assingTexture(material, materialProp, value, tilling);
    return;
  }

  textureLoader.load(
    path,
    (texture) => {
      // console.log("texture is loading");
      texture.magFilter = THREE.NearestFilter;
      texture.minFilter = THREE.NearestMipmapNearestFilter;
      texture.anisotropy = 16;
      texture.flipY = false;
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.wrapS = THREE.RepeatWrapping;
      texture.wrapT = THREE.RepeatWrapping;
      texturePool[id.toLowerCase()] = texture;

      assingTexture(material, materialProp, texture, tilling);
    },
    undefined,
    () => {
      console.error("An error happened.");
    }
  );

  function assingTexture(material, materialProp, texture, tilling) {
    switch (materialProp) {
      case "map":
        material.map = texture;
        if (tilling != null) {
          texture.repeat.set(tilling.x, tilling.y);
        }
        break;
      default:
        break;
    }
    material.needsUpdate = true;
  }
}

// eslint-disable-next-line no-unused-vars
function loadTexture(textureValue, tilingValue = 1) {
  applyTexture(textureValue, tilingValue);

  function applyTexture(textureValue, tilingValue) {
    const textureProperties = {
      Map: {},
      Normal: {},
      Roughness: {},
      Metalness: {},
      Emission: {},
      AO: {},
      Gloss: {},
    };

    for (const node in textureProperties) {
      const value = textureValue[node.toLowerCase()];
      if (!value || value === "null") continue;

      if (value && !textureCache[value]) {
        textureLoader.load(
          value,
          (texture) => {
            // console.log("texture is loading");
            texture.magFilter = THREE.NearestFilter;
            texture.minFilter = THREE.NearestMipmapNearestFilter;
            texture.anisotropy = 16;
            texture.flipY = false;
            setTiling(texture, tilingValue);
            textureCache[value] = texture;
          },
          undefined,
          () => {
            console.error("An error happened.");
          }
        );
      }
    }
  }

  function setTiling(texture, tiling) {
    texture.repeat.set(tiling, tiling);
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.needsUpdate = true;
  }
}

// eslint-disable-next-line no-unused-vars
function setObjectTexture(
  materialNames,
  textureValue,
  tilingValue = 1,
  model = theModel
) {
  model?.traverse((o) => {
    if (o.material) {
      for (let i = 0; i < materialNames.length; i++) {
        if (o.material.name == materialNames[i]) {
          applyTexture(o.material, textureValue, tilingValue);
        }
      }
    }
  });

  function applyTexture(material, textureValue, tilingValue) {
    const textureProperties = {
      Map: {
        apply: (material, texture) => {
          texture.encoding = sRGBEncoding;
          material.map = texture;
          if (texture) material.map.needsUpdate = true;
        },
      },
      Normal: {
        apply: (material, texture) => {
          material.normalMap = texture;
          if (texture) material.normalMap.needsUpdate = true;
        },
      },
      Roughness: {
        apply: (material, texture) => {
          material.roughnessMap = texture;
          if (texture) material.roughnessMap.needsUpdate = true;
        },
      },
      Metalness: {
        apply: (material, texture) => {
          material.metalnessMap = texture;
          if (texture) material.metalnessMap.needsUpdate = true;
        },
      },
      Emission: {
        apply: (material, texture) => {
          material.emissiveMap = texture;
          if (texture) material.emissiveMap.needsUpdate = true;
        },
      },
      AO: {
        apply: (material, texture) => {
          material.aoMap = texture;
          if (texture) material.aoMap.needsUpdate = true;
        },
      },
      Gloss: {
        apply: (material) => {
          material.metalness = 1;
          material.roughness = 0.2;
        },
      },
    };

    for (const node in textureProperties) {
      const value = textureValue[node.toLowerCase()];
      if (!value) continue;

      if (value === "null") {
        textureProperties[node].apply(material, null);
        material.needsUpdate = true;
        continue;
      }

      if (!textureCache[value]) {
        textureLoader.load(
          value,
          (texture) => {
            texture.magFilter = THREE.NearestFilter;
            texture.minFilter = THREE.NearestMipmapNearestFilter;
            texture.anisotropy = 16;
            texture.flipY = false;
            setTiling(texture, tilingValue);
            textureCache[value] = texture;

            textureProperties[node].apply(material, texture);
            material.needsUpdate = true;
          },
          undefined,
          () => {
            console.error("An error happened.");
          }
        );
      } else {
        textureProperties[node].apply(material, textureCache[value]);
        material.needsUpdate = true;
      }
    }
  }

  function setTiling(texture, tiling) {
    texture.repeat.set(tiling, tiling);
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.needsUpdate = true;
  }
}

// eslint-disable-next-line no-unused-vars
function getMeshDimensions(mesh) {
  const boundingBox = new THREE.Box3();
  boundingBox.setFromObject(mesh);
  const size = new THREE.Vector3();
  boundingBox.getSize(size);
  const width = size.x;
  const height = size.y;
  const depth = size.z;
  return { width: width, height: height, depth: depth };
}

// eslint-disable-next-line no-unused-vars
function getMaterialsList(parent) {
  const materials = [];
  parent.traverse((o) => {
    if (o.material) {
      materials.push(o.material.name);
    }
  });
  return materials;
}

// eslint-disable-next-line no-unused-vars
function getMeshNamesList(parent) {
  const names = [];
  parent.traverse((o) => {
    if (o.name) {
      names.push(o.name);
    }
  });
  return names;
}

//#endregion

//#region CLIPBOARD

// eslint-disable-next-line no-unused-vars
const copyToClipboard = (infoSharingInput) => {
  var aux = document.createElement("input");
  aux.setAttribute("value", infoSharingInput.value);
  document.body.appendChild(aux);
  aux.select();
  document.execCommand("copy");
  document.body.removeChild(aux);
};

//#endregion

//#region QR

function CreateQR() {
  var uri = window.location.href;
  var encoded = encodeURIComponent(uri);
  var qrImg = new Image();
  qrImg.src = "https://quickchart.io/qr?text=" + encoded + "&size=200";
  qrImg.addEventListener("load", () => {
    $(qrImg).addClass("ar__bottom__qr");
    $("#qr-container").html(qrImg);
  });
}

async function CheckQRMobile() {
  // eslint-disable-next-line no-unused-vars
  await waitFor((_) => loaded === true);
  // eslint-disable-next-line no-unused-vars
  await waitFor((_) => modelViewer != undefined);
  await new Promise((r) => setTimeout(r, 2000));

  if (qrScaned == 1) {
    if (
      getMobileOperatingSystem() == "Android" ||
      getMobileOperatingSystem() == "iOS"
    ) {
      OpenAR();
    }

    qrScaned = 0;

    WriteURLParameters();
  }
}

//#endregion

//#region AR
let originalWallStates = {
  backWall: false,
  leftWall: false,
  rightWall: false
};
let arListenersInitialized = false;
let arPollingInterval;
let isARActive = false;

function PrepareAR() {
  modelViewer = $("#marevo_model");
  const arPromt = $("#ar-prompt");

  if (!arListenersInitialized) {
    arListenersInitialized = true;

    modelViewer[0].addEventListener("ar-status", async (event) => {
      console.log("AR Status:", event.detail.status);

      if (event.detail.status == "session-started") {
        isARActive = true;
        arPromt[0].style.display = "block";
        startARPolling();
      } else if (event.detail.status == "not-presenting") {
        console.log("AR session ended, resetting everything");
        isARActive = false;
        arPromt[0].style.display = "none";

        if (arPollingInterval) {
          clearInterval(arPollingInterval);
          arPollingInterval = null;
        }

        // reinitialisation of model-viewer for AR
        setTimeout(() => {
          forceReinitializeModelViewer();
          restoreWallsAfterAR();
        }, 1000);
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && isARActive) {
        console.log("Page visible, AR was active, resetting");
        isARActive = false;
        setTimeout(() => {
          forceReinitializeModelViewer();
          restoreWallsAfterAR();
        }, 1000);
      }
    });
  }

  // reinitialisation of the activateAR override (don't check if already initialized)
  const originalActivateAR = modelViewer[0].activateAR.bind(modelViewer[0]);
  modelViewer[0].activateAR = function () {
    console.log("AR activation intercepted, isARActive:", isARActive);

    isARActive = true;
    startARPolling();

    try {
      return originalActivateAR();
    } catch (error) {
      console.log("Error calling original activateAR:", error);
      isARActive = false;
      return Promise.reject(error);
    }
  };
}

function forceReinitializeModelViewer() {
  console.log("Force reinitializing model-viewer");

  try {
    const element = modelViewer[0];

    // removing and re-adding AR attributes to force reinitialization
    element.removeAttribute('ar');
    element.removeAttribute('ar-modes');

    // force a repaint/reflow
    element.offsetHeight;

    // returning  AR attributes
    setTimeout(() => {
      element.setAttribute('ar', '');
      element.setAttribute('ar-modes', 'webxr scene-viewer quick-look');

      // force model-viewer to reinitialize AR
      if (element.requestUpdate) {
        element.requestUpdate();
      }

      // reinitialisation the AR override
      const originalActivateAR = element.activateAR.bind(element);
      element.activateAR = function () {
        console.log("AR activation after reinit, isARActive:", isARActive);
        isARActive = true;
        startARPolling();
        return originalActivateAR();
      };

      console.log("Model-viewer AR reinitialized");
    }, 100);

  } catch (error) {
    console.log("Error reinitializing model-viewer:", error);
  }
}

function startARPolling() {
  if (arPollingInterval) {
    clearInterval(arPollingInterval);
  }

  console.log("Starting AR polling");
  arPollingInterval = setInterval(() => {
    if (modelViewer[0] && !modelViewer[0].canActivateAR && isARActive) {
      console.log("AR polling detected AR closed");
      isARActive = false;
      clearInterval(arPollingInterval);
      arPollingInterval = null;

      setTimeout(() => {
        forceReinitializeModelViewer();
        restoreWallsAfterAR();
      }, 500);
    }
  }, 1000);
}

async function restoreWallsAfterAR() {
  if (!originalWallStates ||
    (originalWallStates.backWall === undefined &&
      originalWallStates.leftWall === undefined &&
      originalWallStates.rightWall === undefined)) {
    return;
  }

  state.backWall = originalWallStates.backWall;
  state.leftWall = originalWallStates.leftWall;
  state.rightWall = originalWallStates.rightWall;

  try {
    const wallBack = GetGroup("wall_back");
    const wallL = GetGroup("wall_L");
    const wallR = GetGroup("wall_R");
    if (wallBack) console.log("wall_back length:", wallBack.children.length);
    if (wallL) console.log("wall_L length:", wallL.children.length);
    if (wallR) console.log("wall_R length:", wallR.children.length);
  } catch (error) {
    console.log("Error getting wall groups:", error);
    return;
  }

  try {
    if (typeof toggleBackWall === 'function') {
      await toggleBackWall(originalWallStates.backWall);
    }
    if (typeof toggleLeftWall === 'function') {
      await toggleLeftWall(originalWallStates.leftWall);
    }
    if (typeof toggleRightWall === 'function') {
      await toggleRightWall(originalWallStates.rightWall);
    }
  } catch (error) {
    console.log("Error toggling walls:", error);
  }
}

async function OpenAR() {
  // recompute and import scene for AR
  ComputeMorphedAttributes();
  await ImportScene(scene);

  if (getMobileOperatingSystem() == "iOS") {
    if (pergola != null) {
      if (pergolaSettings.mountingWall_Back) {
        pergola.changeMountingWallVisibility(
          pergolaSettings.mountingWall_Back,
          PergolaElementOrientSide.Back,
          true
        );
      }
      if (pergolaSettings.mountingWall_Left) {
        pergola.changeMountingWallVisibility(
          pergolaSettings.mountingWall_Left,
          PergolaElementOrientSide.Left,
          true
        );
      }
      if (pergolaSettings.mountingWall_Right) {
        pergola.changeMountingWallVisibility(
          pergolaSettings.mountingWall_Right,
          PergolaElementOrientSide.Right,
          true
        );
      }
    }
  }
}

// eslint-disable-next-line no-unused-vars
export function OpenARorQR() {
  console.log("click AR");
  if (
    getMobileOperatingSystem() == "Android" ||
    getMobileOperatingSystem() == "iOS"
  ) {

    originalWallStates = {
      backWall: state.backWall,
      leftWall: state.leftWall,
      rightWall: state.rightWall
    };

    state.backWall = false;
    state.leftWall = false;
    state.rightWall = false;

    if (typeof toggleBackWall === 'function') toggleBackWall(false);
    if (typeof toggleLeftWall === 'function') toggleLeftWall(false);
    if (typeof toggleRightWall === 'function') toggleRightWall(false);

    OpenAR();
    return;
  }
  CreateQR();
  $("#ar").show();
}

//IMPORT
async function ImportScene(newScene) {
  // console.log(modelViewer[0], newScene); 
  await modelViewer[0].importScene(newScene);
  modelViewer[0].activateAR();
}
//#endregion

//#region URL PARAMETERS

function ReadURLParameters(callback, url = null) {
  var queryString = url != null ? url : window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const entries = urlParams.entries();
  let parseParams = "";

  for (const entry of entries) {
    if (entry[0] == parametersKey) {
      parseParams = entry[1];
      continue;
    }

    if (entry[0] == "onlyAR") {
      var parameter = entry[1];

      setRedirectionProjectSettings(parameter == "true" ? true : false);
      continue;
    }
  }

  if (parseParams === "undefined") {
    paramsLoaded = true;
    if (callback != null) {
      callback();
    }
    return;
  }

  if (parseParams === undefined || parseParams == null || parseParams == "") {
    paramsLoaded = true;
    if (callback != null) {
      callback();
    }
    return;
  }

  if (!parseParams?.trim()) {
    paramsLoaded = true;
    if (callback != null) {
      callback();
    }
    return;
  }

  var splitValue = "-";
  parseParams = parseParams.SDecode();

  const paramArray = parseParams.split(splitValue);
  // console.log(paramArray);

  if (paramArray.length == 0) {
    paramsLoaded = true;
    if (callback != null) {
      callback();
    }
    return;
  }

  //var pergolaSettings = new PergolaSettings();

  pergolaSettings.width = parseInt(paramArray[0]);
  pergolaSettings.length = parseInt(paramArray[1]);
  pergolaSettings.height = parseInt(paramArray[2]);
  pergolaSettings.postSize = parseInt(paramArray[3]);
  pergolaSettings.colorHex = paramArray[4];
  pergolaSettings.colorLouveredHex = paramArray[5];
  pergolaSettings.colorLedHex = paramArray[6];
  pergolaSettings.colorMoodHex = paramArray[7];
  pergolaSettings.roofType = parseInt(paramArray[8]);
  pergolaSettings.roofLouveredDirection = parseInt(paramArray[9]);
  pergolaSettings.roofLouveredRotate = parseInt(paramArray[10]);
  pergolaSettings.mountingWall_Back =
    parseInt(paramArray[11]) == 1 ? true : false;
  pergolaSettings.mountingWall_Left =
    parseInt(paramArray[12]) == 1 ? true : false;
  pergolaSettings.mountingWall_Right =
    parseInt(paramArray[13]) == 1 ? true : false;
  pergolaSettings.extraOptionLight =
    parseInt(paramArray[14]) == 1 ? true : false;
  pergolaSettings.extraOptionLightSpacing = parseInt(paramArray[15]);
  pergolaSettings.extraOptionFan = parseInt(paramArray[16]) == 1 ? true : false;
  pergolaSettings.extraOptionLed = parseInt(paramArray[17]) == 1 ? true : false;
  pergolaSettings.extraOptionHeaters =
    parseInt(paramArray[18]) == 1 ? true : false;
  pergolaSettings.extraOptionMoodLight =
    parseInt(paramArray[19]) == 1 ? true : false;

  sceneTime = parseInt(paramArray[20]) == 1 ? "Night" : "Day";
  qrScaned = parseInt(paramArray[21]);

  if (callback != null) callback();

  CheckQRMobile();
}

function ReadStringParameters(inputParameters, callback) {
  if (inputParameters == null) {
    if (callback != null) {
      callback();
    }
    return;
  }

  if (
    inputParameters == "" ||
    inputParameters == "null" ||
    inputParameters == "undefined"
  ) {
    paramsLoaded = true;
    if (callback != null) {
      callback();
    }
    return;
  }

  if (
    inputParameters == "" ||
    inputParameters == null ||
    inputParameters == undefined
  ) {
    paramsLoaded = true;
    if (callback != null) {
      callback();
    }
    return;
  }

  var splitValue = "-";
  var parseParams = inputParameters.SDecode();

  const paramArray = parseParams.split(splitValue);
  console.log(paramArray);

  if (paramArray.length == 0) {
    paramsLoaded = true;
    if (callback != null) {
      callback();
    }
    return;
  }

  //var pergolaSettings = new PergolaSettings();

  pergolaSettings.width = parseInt(paramArray[0]);
  pergolaSettings.length = parseInt(paramArray[1]);
  pergolaSettings.height = parseInt(paramArray[2]);
  pergolaSettings.postSize = parseInt(paramArray[3]);
  pergolaSettings.colorHex = paramArray[4];
  pergolaSettings.colorLouveredHex = paramArray[5];
  pergolaSettings.colorLedHex = paramArray[6];
  pergolaSettings.colorMoodHex = paramArray[7];
  pergolaSettings.roofType = parseInt(paramArray[8]);
  pergolaSettings.roofLouveredDirection = parseInt(paramArray[9]);
  pergolaSettings.roofLouveredRotate = parseInt(paramArray[10]);
  pergolaSettings.mountingWall_Back =
    parseInt(paramArray[11]) == 1 ? true : false;
  pergolaSettings.mountingWall_Left =
    parseInt(paramArray[12]) == 1 ? true : false;
  pergolaSettings.mountingWall_Right =
    parseInt(paramArray[13]) == 1 ? true : false;
  pergolaSettings.extraOptionLight =
    parseInt(paramArray[14]) == 1 ? true : false;
  pergolaSettings.extraOptionLightSpacing = parseInt(paramArray[15]);
  pergolaSettings.extraOptionFan = parseInt(paramArray[16]) == 1 ? true : false;
  pergolaSettings.extraOptionLed = parseInt(paramArray[17]) == 1 ? true : false;
  pergolaSettings.extraOptionHeaters =
    parseInt(paramArray[18]) == 1 ? true : false;
  pergolaSettings.extraOptionMoodLight =
    parseInt(paramArray[19]) == 1 ? true : false;
  sceneTime = parseInt(paramArray[20]) == 1 ? "Night" : "Day";
  qrScaned = parseInt(paramArray[21]);

  if (callback != null) callback();

  //CheckQRMobile();
}

// eslint-disable-next-line no-unused-vars
var wix_url_base = null;
var wix_current_url = null;
var wix_url_load_params = null;

// eslint-disable-next-line no-unused-vars
function PostMassagesListener(event) {
  let receivedMessage = event.data;
  //console.log("Отримано повідомлення з main сайту:", receivedMessage);

  if (receivedMessage == "undefined") {
    return;
  }
  if (receivedMessage == undefined) {
    return;
  }
  if (receivedMessage == null) {
    return;
  }

  if (receivedMessage.includes("WIX_URL_LOAD|")) {
    return;
  }
  if (receivedMessage.includes("WIX_CURRENT_URL|")) {
    wix_current_url = receivedMessage.replace("WIX_CURRENT_URL|", "");
    return;
  }
  if (receivedMessage.includes("WIX_URL_LOAD_Params|")) {
    wix_url_load_params = receivedMessage.replace("WIX_URL_LOAD_Params|", "");
    var url =
      location.protocol + "//" + location.host + location.pathname + "?";
    history.pushState(null, "marevo", url + "config=" + wix_url_load_params);
    return;
  }
  if (receivedMessage.includes("URL_Params|")) {
    return;
  }
  if (receivedMessage.includes("WIX_URL_BASE|")) {
    wix_url_base = receivedMessage.replace("WIX_URL_BASE|", "");
    return;
  }

  if (receivedMessage.includes("WIX_IS_LOADED|")) {
    return;
  }
}

if (window.addEventListener) {
  // window.addEventListener("message", PostMassagesListener); //! for WIX
} else {
  // IE8
  // window.attachEvent("onmessage", PostMassagesListener); //! for WIX
}

export function WriteURLParameters() {
  if (!paramsLoaded) {
    return;
  }
  if (blockURLWriter) {
    return;
  }

  if (!delayForWriteURL) {
    delayForWriteURL = true;
    promiseDelay(100, function () {
      history.pushState(null, "marevo", GetURLWithParameters());
      if (isWIX == true) {
        window.parent.postMessage(
          "URL_Params|" + GetURLWithParameters("", true),
          "*"
        );
      }
      delayForWriteURL = false;
    });
  }
}

export function GetParametersString() {
  parametersValue = "";

  if (pergolaSettings == null) {
    return parametersValue;
  }

  var splitValue = "-";

  parametersValue += pergolaSettings.width + splitValue;
  parametersValue += pergolaSettings.length + splitValue;
  parametersValue += pergolaSettings.height + splitValue;
  parametersValue += pergolaSettings.postSize + splitValue;
  parametersValue += pergolaSettings.colorHex + splitValue;
  parametersValue += pergolaSettings.colorLouveredHex + splitValue;
  parametersValue += pergolaSettings.colorLedHex + splitValue;
  parametersValue += pergolaSettings.colorMoodHex + splitValue;
  parametersValue += pergolaSettings.roofType + splitValue;
  parametersValue += pergolaSettings.roofLouveredDirection + splitValue;
  parametersValue += pergolaSettings.roofLouveredRotate + splitValue;
  parametersValue +=
    (pergolaSettings.mountingWall_Back == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.mountingWall_Left == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.mountingWall_Right == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.extraOptionLight == true ? 1 : 0) + splitValue;
  parametersValue += pergolaSettings.extraOptionLightSpacing + splitValue;
  parametersValue +=
    (pergolaSettings.extraOptionFan == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.extraOptionLed == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.extraOptionHeaters == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.extraOptionMoodLight == true ? 1 : 0) + splitValue;
  parametersValue += (sceneTime == "Night" ? 1 : 0) + splitValue;
  parametersValue += qrScaned;

  parametersValue = parametersValue.SEncode();

  return parametersValue;
}

export function GetURLWithParameters(updateURL = null, withoutKey = false) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const entries = urlParams.entries();

  var url = location.protocol + "//" + location.host + location.pathname + "?";

  if (updateURL != null) {
    url = updateURL + "?";
  }

  var configEmpty = true;

  for (const entry of entries) {
    if (entry[0] == parametersKey) {
      url += parametersKey + "=" + GetParametersString() + "&";
      configEmpty = false;
    } else if (entry[0] == "onlyAR") {
      continue;
    } else {
      url += entry[0] + "=" + entry[1] + "&";
    }
  }

  if (configEmpty) {
    url += parametersKey + "=" + GetParametersString();
  }

  if (withoutKey) {
    url = url.replace("?" + parametersKey + "=", "");
  }

  if (url.endsWith("&")) {
    url = url.substring(0, url.length - 1);
  }

  return url;
}

// eslint-disable-next-line no-unused-vars
function delay(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

//#endregion

//#region UTILS

function waitFor(conditionFunction) {
  const poll = (resolve) => {
    if (conditionFunction()) resolve();
    // eslint-disable-next-line no-unused-vars
    else setTimeout((_) => poll(resolve), 400);
  };

  return new Promise(poll);
}

function promiseDelay(time, callback) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve("resolved");
      if (callback != null) {
        callback();
      }
    }, time);
  });
}

// eslint-disable-next-line no-unused-vars
async function waitForValueChange(input, result, callback) {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (input === result) {
        clearInterval(interval);
        resolve();

        if (callback != null) {
          callback();
        }
      }
    }, 100);
  });
}

//#endregion

//#region SHADER and MORPHS

function Shader_ChangeVertexToWorldpos(object) {
  var vUvSymbol = "vUv";
  var uvTransformSymbol = "uvTransform";

  if (THREE.REVISION >= 150) {
    vUvSymbol = "vMapUv";
    uvTransformSymbol = "mapTransform";
  }

  promiseDelayShaderSettings(500, object, () => {
    if (object.isMesh) {
      if (isWorldposVertexShaderEnabled) {
        if (object.material) {
          if (object.material.name.includes("_Z")) {
            object.material.onBeforeCompile = (shader) => {
              shader.vertexShader = shader.vertexShader
                .replace("#include <uv_vertex>\n", "")
                .replace(
                  "#include <worldpos_vertex>",
                  `vec4 worldPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\nworldPosition = instanceMatrix * worldPosition;\n#endif\nworldPosition = modelMatrix * worldPosition;\n${vUvSymbol} = (${uvTransformSymbol} * vec3(worldPosition.xz, 1)).xy;`
                );
            };
          } else if (object.material.name.includes("_Y")) {
            object.material.onBeforeCompile = (shader) => {
              shader.vertexShader = shader.vertexShader
                .replace("#include <uv_vertex>\n", "")
                .replace(
                  "#include <worldpos_vertex>",
                  `vec4 worldPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\nworldPosition = instanceMatrix * worldPosition;\n#endif\nworldPosition = modelMatrix * worldPosition;\n${vUvSymbol} = (${uvTransformSymbol} * vec3(worldPosition.xy, 1)).xy;`
                );
            };
          } else if (object.material.name.includes("_X")) {
            object.material.onBeforeCompile = (shader) => {
              shader.vertexShader = shader.vertexShader
                .replace("#include <uv_vertex>\n", "")
                .replace(
                  "#include <worldpos_vertex>",
                  `vec4 worldPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\nworldPosition = instanceMatrix * worldPosition;\n#endif\nworldPosition = modelMatrix * worldPosition;\n${vUvSymbol} = (${uvTransformSymbol} * vec3(worldPosition.yz, 1)).xy;`
                );
            };
          }
          object.material.needsUpdate = true;
        }
      }
    }
  });
}

function promiseDelayShaderSettings(time, object, callback) {
  if (time == null) {
    time = 2000;
  }

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve("resolved");
      if (object.material.map == null) {
        promiseDelayShaderSettings(time, object, callback);
      } else {
        if (callback != null) {
          callback();
        }
      }
    }, time);
  });
}

function InitMorphModel(model) {
  //var BufferGeometryUtils_script = document.createElement('script');
  //BufferGeometryUtils_script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/three@0.147/examples/js/utils/BufferGeometryUtils.js');
  //document.body.appendChild(BufferGeometryUtils_script);

  ParseMorphByModel(model);
}

export function ParseMorphByModel(model, callback = null) {
  morphs = [];
  model.traverse((object) => {
    if (object.isMesh) {
      Shader_ChangeVertexToWorldpos(object);

      if (object.morphTargetDictionary != null) {
        for (const [key, value] of Object.entries(
          object.morphTargetDictionary
        )) {
          var morph = {
            name: key,
            object: object,
            key: value,
            value: value,
          };

          if (!morphs.includes(morph)) {
            morphs.push(morph);
          }
        }
      }
    }
  });

  PrepareGlobalMorphs(callback);
}

function PrepareGlobalMorphs(callback = null) {
  globalMorphs = [];

  for (let index = 0; index < morphs.length; index++) {
    const morph = morphs[index];

    var hasMorph = false;

    for (let m = 0; m < globalMorphs.length; m++) {
      const globalMorph = globalMorphs[m];
      if (globalMorph.name != morph.name) {
        continue;
      }
      hasMorph = true;
      break;
    }

    if (!hasMorph) {
      globalMorphs.push(morph);
    }
  }

  if (callback != null) {
    callback();
  }
}

function ComputeMorphedAttributes() {
  for (let index = 0; index < morphs.length; index++) {
    const morph = morphs[index];
    var computeMorphedAttributesValue = computeMorphedAttributes(morph.object);
    morph.object.geometry.computeMorphedAttributes =
      computeMorphedAttributesValue;
  }
}

// eslint-disable-next-line no-unused-vars
function ChangeObjectMorph(morph, inputvalue) {
  if (morph.object == null) {
    return;
  }

  if (morph.object.isMesh) {
    if (morph.object.morphTargetInfluences != null) {
      morph.object.morphTargetInfluences[morph.key] = inputvalue;
    }
  }
}

// eslint-disable-next-line no-unused-vars
export function ChangeObjectWithMorph(object, key, inputvalue) {
  if (object == null) {
    return;
  }

  if (object.morphTargetInfluences != null) {
    object.morphTargetInfluences[key] = inputvalue;
  }
}

export function ChangeGlobalMorph(morphName, inputvalue) {
  for (let index = 0; index < morphs.length; index++) {
    const morph = morphs[index];

    if (morph.name != morphName) {
      continue;
    }
    if (morph.object == null) {
      continue;
    }
    if (!morph.object.isMesh) {
      continue;
    }
    if (morph.object.morphTargetInfluences == null) {
      continue;
    }

    morph.object.morphTargetInfluences[morph.key] = inputvalue;
  }
}

export function ClipMeshWithDashedEffectAfterMorph(mesh, step = 1, gap = 0.3) {
  if (
    !mesh ||
    !mesh.geometry ||
    !(mesh.geometry instanceof THREE.BufferGeometry)
  ) {
    console.error("Невалідний меш для обрізання.");
    return;
  }

  // Забезпечити оновлення геометрії
  mesh.geometry.applyMatrix4(mesh.matrixWorld);
  mesh.geometry = mesh.geometry.toNonIndexed(); // Робимо геометрію неіндексованою
  const geometry = mesh.geometry.clone(); // Клонування геометрії для роботи

  const positions = geometry.attributes.position.array; // Масив позицій
  if (!positions) {
    console.error("Геометрія не містить позицій вершин.");
    return;
  }

  const newPositions = [];
  const vertexStepMap = []; // Для зберігання фільтруваних вершин

  const totalLength = step; // Довжина одного сегмента (зубчик + прогалина)
  const gapStart = step - gap; // Межа початку прогалини

  // Обробка вершин для створення штрихованого ефекту по осі Z
  for (let i = 0; i < positions.length; i += 3) {
    const zPos = positions[i + 2]; // Координата Z для поточної вершини

    // Округлення для усунення похибок плаваючої точки
    const normalizedPosition =
      zPos - Math.floor(zPos / totalLength) * totalLength;

    // Перевіряємо, чи вершина знаходиться в зоні штриха
    if (normalizedPosition < gapStart) {
      newPositions.push(positions[i], positions[i + 1], positions[i + 2]);
      vertexStepMap.push(newPositions.length / 3 - 1); // Маркуємо як частину штриха
    } else {
      vertexStepMap.push(-1); // Прогалина
    }
  }

  // Створення нових індексів
  const newIndices = [];
  const oldIndices = geometry.index ? geometry.index.array : null;

  if (oldIndices) {
    for (let j = 0; j < oldIndices.length; j += 3) {
      const v1 = vertexStepMap[oldIndices[j]];
      const v2 = vertexStepMap[oldIndices[j + 1]];
      const v3 = vertexStepMap[oldIndices[j + 2]];

      // Додаємо тільки трикутники, які не містять прогалини
      if (v1 >= 0 && v2 >= 0 && v3 >= 0) {
        newIndices.push(v1, v2, v3);
      }
    }
  }

  // Створення фінальної геометрії
  const dashedGeometry = new THREE.BufferGeometry();
  dashedGeometry.setAttribute(
    "position",
    new THREE.BufferAttribute(new Float32Array(newPositions), 3)
  );

  if (newIndices.length > 0) {
    dashedGeometry.setIndex(newIndices);
  }

  // Оновлення геометрії у меші
  mesh.geometry.dispose(); // Звільнити стару геометрію
  mesh.geometry = dashedGeometry;
  mesh.geometry.computeBoundingBox();
  mesh.geometry.computeBoundingSphere();
}

export function ConvertMorphValue(
  inputval,
  srcStart,
  srcEnd,
  destStart = 0,
  destEnd = 1
) {
  const result =
    destStart +
    ((inputval - srcStart) * (destEnd - destStart)) / (srcEnd - srcStart);
  return result;
}

export function ConvertMorphValueReverse(
  outputVal,
  srcStart,
  srcEnd,
  destStart = 0,
  destEnd = 1
) {
  const result =
    srcStart +
    ((outputVal - destStart) * (srcEnd - srcStart)) / (destEnd - destStart);
  return result;
}

// eslint-disable-next-line no-unused-vars
function animateMorph(
  morphName,
  valueStart,
  valueEnd,
  callback = () => { },
  timeInterval = 200,
  steps = 5
) {
  DEBUG_MODE_VALUES && console.log("🚀 ~ animateMorph ~ ");
  const stepDuration = timeInterval / steps;
  const stepValue = (valueEnd - valueStart) / steps;
  let currentValue = valueStart;
  let completedSteps = 0;

  for (let i = 1; i <= steps; i++) {
    setTimeout(() => {
      ChangeGlobalMorph(morphName, currentValue);
      currentValue += stepValue;
      completedSteps++;
      if (completedSteps === steps) {
        ChangeGlobalMorph(morphName, valueEnd);
        callback();
      }
    }, i * stepDuration);
  }
}

//#endregion

//#region PROJECT FUNCTIONS PERGOLA

export function generateMidpoints(
  vectorA,
  vectorB,
  numPoints,
  isFirstLastPointAdded = false
) {
  const points = [];
  if (isFirstLastPointAdded) {
    points.push(vectorA.clone());
  }
  for (let i = 1; i <= numPoints; i++) {
    const t = i / (numPoints + 1);
    const point = new THREE.Vector3().lerpVectors(vectorA, vectorB, t);
    points.push(point);
  }
  if (isFirstLastPointAdded) {
    points.push(vectorB.clone());
  }
  return points;
}

export function generateCenterMidpoints(
  vectorA,
  vectorB,
  numPoints,
  isFirstLastPointAdded = false,
  divide = 1
) {
  const points = [];
  if (isFirstLastPointAdded) {
    points.push(vectorA);
  }
  for (let i = 1; i <= numPoints; i++) {
    const t = i / (numPoints + 1);
    const point = new THREE.Vector3().lerpVectors(vectorA, vectorB, t);
    points.push(point);
  }
  if (isFirstLastPointAdded) {
    points.push(vectorB);
  }
  if (points.length == 1) {
    return points;
  }
  var dividePoints = points;
  for (let index = 0; index < divide; index++) {
    dividePoints = pointDivideProcess(dividePoints);
  }
  return dividePoints;
}

function pointDivideProcess(points) {
  const dividePoint = [];

  for (let i = 0; i < points.length; i++) {
    if (i + 1 >= points.length) {
      continue;
    }

    var point1 = points[i];
    var point2 = points[i + 1];
    const centerPoint = new THREE.Vector3().lerpVectors(point1, point2, 0.5);

    dividePoint.push(centerPoint);
  }

  return dividePoint;
}

function setValueToCoordinates(points, axis, value) {
  for (let i = 0; i < points.length; i++) {
    points[i][axis] = value;
  }
}

var pointLights = [];
var ledLights = [];
var moodLeds = [];

export class PergolaObject {
  constructor(settings) {
    this.productId = "";
    this.name = "";
    this.dimensions = new PergolaDimensions();
    this.post = new PergolaPost();
    this.color = new PergolaColorElement();
    this.roof = new PergolaRoof();
    this.mountingWall = new PergolaMountingWall();
    this.extraOptions = new PergolaExtraOptions();
    this.labelObject = null;
    this.settings = settings;
    this.lastSettings = new PergolaSettings();
    this.theModel = null;
    this.totalWidth = 0;
    this.totalHeight = 0;
    this.totalLength = 0;
  }

  createFrom3DModel(model) {
    pointLights = [];
    ledLights = [];
    moodLeds = [];

    this.theModel = model;
    model.traverse((o) => {
      if (o.name.includes("lable")) {
        this.labelObject = o;
      }

      //POSTS
      if (o.name.includes("posr")) {
        var postObject = new PergolaPostObject();
        postObject.name = o.name;
        postObject.object = o;
        postObject.isSupport = false;

        if (o.name.includes("b_L")) {
          postObject.side = PergolaPostSide.RL;
        } else if (o.name.includes("b_R")) {
          postObject.side = PergolaPostSide.RR;
        } else if (o.name.includes("f_L")) {
          postObject.side = PergolaPostSide.FL;
        } else if (o.name.includes("f_R")) {
          postObject.side = PergolaPostSide.FR;
        } else if (o.name.includes("f_C")) {
          postObject.side = PergolaPostSide.FC;
          postObject.isSupport = true;
        } else if (o.name.includes("b_C")) {
          postObject.side = PergolaPostSide.BC;
          postObject.isSupport = true;
        } else if (o.name.includes("L_C")) {
          postObject.side = PergolaPostSide.LC;
          postObject.isSupport = true;
        } else if (o.name.includes("R_C")) {
          postObject.side = PergolaPostSide.RC;
          postObject.isSupport = true;
        } else if (o.name === "posr_С") {
          postObject.side = PergolaPostSide.CC;
          postObject.isSupport = true;
        } else {
          postObject.side = PergolaPostSide.RL;
        }

        this.post.objects.push(postObject);
      }

      // ROOF
      if (o.name.includes("header")) {
        o.visible = true;
      }

      // FRAME
      if (o.name === "louver_frame") {
        const frameObject = new PergolaRoofFrame();
        frameObject.object = o;
        this.roof.frames.push(frameObject);
      }

      // BEAMs
      if (o.name.includes("beam")) {
        var beamObject = null;
        beamObject = new PergolaRoofBeam();
        beamObject.object = o;

        if (o.name.includes("8x2")) {
          beamObject.direction = PergolaRoofDirection.Straight;
          beamObject.isFanBeam = true;
        } else {
          if (o.name.includes("_X")) {
            beamObject.direction = PergolaRoofDirection.Straight;
            beamObject.isFanBeam = false;
          } else if (o.name.includes("_Y")) {
            beamObject.direction = PergolaRoofDirection.Perpendicular;
            beamObject.isFanBeam = false;
          }
        }

        this.roof.beams.push(beamObject);
      }

      // WALLs
      if (o.name.includes("wall")) {
        var mountingWall = new PergolaMountingWallElement();
        mountingWall.object = o;

        if (o.name.includes("_R")) {
          mountingWall.side = PergolaElementOrientSide.Right;
        } else if (o.name.includes("_L")) {
          mountingWall.side = PergolaElementOrientSide.Left;
        } else if (o.name.includes("_back")) {
          mountingWall.side = PergolaElementOrientSide.Back;
        } else {
          mountingWall.side = PergolaElementOrientSide.Right;
        }

        this.mountingWall.elements.push(mountingWall);
      }

      // Fan
      if (o.name.includes("fan")) {
        var fan = new PergolaExtraOptionElement();

        fan.type = PergolaExtraOptionType.fan;
        fan.object = o;

        this.extraOptions.elements.push(fan);
      }

      // Heater
      if (o.name.includes("UFO")) {
        var heater = new PergolaExtraOptionElement();

        heater.type = PergolaExtraOptionType.heater;
        heater.object = o;

        this.extraOptions.elements.push(heater);
      }

      // Point Light
      if (o.name.includes("point-light")) {
        var pointLight = new PergolaExtraOptionElement();

        pointLight.type = PergolaExtraOptionType.light;
        pointLight.object = o;

        // if (getMobileOperatingSystem() != "Android" || getMobileOperatingSystem() != "iOS") {
        //   const light = new THREE.PointLight(0xffffff, 0, 10);
        //   light.position.set(0, -0.1, 0);
        //   pointLight.object.add(light);
        //   pointLights.push(light);
        // }

        this.extraOptions.elements.push(pointLight);
      }

      // LED Strip
      if (o.name.includes("frame") && o.name.includes("LED")) {
        const ledLight = new PergolaExtraOptionElement();

        ledLight.type = PergolaExtraOptionType.led;
        ledLight.object = o;

        if (
          getMobileOperatingSystem() != "Android" ||
          getMobileOperatingSystem() != "iOS"
        ) {
          //! TODO
          // const light = new THREE.PointLight(0xffffff, 0, 10);
          // light.position.set(0, -0.1, 0);
          // ledLight.object.add(light);
          // ledLights.push(light);
        }

        this.extraOptions.elements.push(ledLight);
      }

      // LED Strip MOOD LIGHTING
      if (o.name.includes("frame") && o.name.includes("001")) {
        const ledMood = new PergolaExtraOptionElement();

        ledMood.type = PergolaExtraOptionType.moodLed;
        ledMood.object = o;

        if (
          getMobileOperatingSystem() != "Android" ||
          getMobileOperatingSystem() != "iOS"
        ) {
          //! TODO
          // const light = new THREE.PointLight(0xffffff, 0, 10);
          // light.position.set(0, -0.1, 0);
          // ledMood.object.add(light);
          // ledMood.push(light);
        }

        this.extraOptions.elements.push(ledMood);
      }
    });

    // ROOF
    var roofTypeLouvered = new PergolaRoofTypeLouvered();
    model.traverse((o) => {
      if (o.name.includes("louver") && !o.name.includes("frame")) {
        var louveredObject = new PergolaRoofTypeLouveredObject();
        louveredObject.object = o;
        roofTypeLouvered.objects.push(louveredObject);
      }
    });

    this.roof.louvered = roofTypeLouvered;

    this.prepareBeams();
    this.prepareFrames();
    this.prepareLouvereds();
    this.prepareExtraOptions();

    // show corner posts
    const FL_Post = this.getPostObject(null, PergolaPostSide.FL);
    const FR_Post = this.getPostObject(null, PergolaPostSide.FR);
    const RL_Post = this.getPostObject(null, PergolaPostSide.RL);
    const RR_Post = this.getPostObject(null, PergolaPostSide.RR);

    FL_Post.visible = true;
    FR_Post.visible = true;
    RL_Post.visible = true;
    RR_Post.visible = true;

    this.cloneMaterialTexture("wall");
    this.cloneMaterialTexture("wall_side");
    this.cloneMaterialTexture("wall_tile");

    ParseMorphByModel(model);

    this.update();
  }

  cloneLouveredObject(count) {
    var element = this.roof.louvered.objects[0];
    if (element == null) {
      return;
    }

    for (let index = 0; index < count; index++) {
      var clonedMesh = element.object.clone();
      clonedMesh.visible = false;

      var parent = scene.getObjectByName("Scene");

      if (parent != null) {
        parent.add(clonedMesh);
      } else {
        scene.add(clonedMesh);
      }

      var louveredObject = new PergolaRoofTypeLouveredObject();
      louveredObject.object = clonedMesh;

      this.roof.louvered.objects.push(louveredObject);
    }
  }

  cloneBeamObject(direction, count, isFanBeam = false) {
    var element = this.roof.beams.find(
      (item) => item.isFanBeam == isFanBeam && item.direction == direction
    );
    if (element == null) {
      return;
    }

    for (let index = 0; index < count; index++) {
      var clonedMesh = element.object.clone();
      clonedMesh.visible = false;

      var parent = scene.getObjectByName("Scene");

      if (parent != null) {
        parent.add(clonedMesh);
      } else {
        scene.add(clonedMesh);
      }

      var beamObject = new PergolaRoofBeam();
      beamObject.direction = direction;
      beamObject.object = clonedMesh;
      beamObject.isFanBeam = isFanBeam;

      this.roof.beams.push(beamObject);
    }
  }

  cloneFrameObject(count) {
    const element = this.roof.frames[0];
    if (element == null) {
      return;
    }

    for (let index = 0; index < count; index++) {
      const clonedMesh = element.object.clone();
      clonedMesh.visible = false;

      const parent = scene.getObjectByName("Scene");

      if (parent != null) {
        parent.add(clonedMesh);
      } else {
        scene.add(clonedMesh);
      }

      const frameObject = new PergolaRoofFrame();
      frameObject.object = clonedMesh;

      this.roof.frames.push(frameObject);
    }
  }

  cloneExtraOptionObject(type, count) {
    var element = this.extraOptions.elements.find((item) => item.type == type);
    if (element == null && type != PergolaExtraOptionType.moodLight) {
      return;
    }

    if (type != PergolaExtraOptionType.moodLight) {
      for (let index = 0; index < count; index++) {
        var extraOptionElement = new PergolaExtraOptionElement();
        extraOptionElement.type = element.type;

        var clonedMesh = element.object.clone();
        clonedMesh.visible = false;

        if (
          getMobileOperatingSystem() != "Android" ||
          getMobileOperatingSystem() != "iOS"
        ) {
          if (type == PergolaExtraOptionType.light) {
            for (let l = 0; l < clonedMesh.children.length; l++) {
              const element = clonedMesh.children[l];
              if (!element.isLight) {
                continue;
              }
              pointLights.push(element);
            }
          }

          if (type == PergolaExtraOptionType.led) {
            for (let l = 0; l < clonedMesh.children.length; l++) {
              const element = clonedMesh.children[l];
              if (!element.isLight) {
                continue;
              }
              ledLights.push(element);
            }
          }

          if (type == PergolaExtraOptionType.moodLed) {
            for (let l = 0; l < clonedMesh.children.length; l++) {
              const element = clonedMesh.children[l];
              if (!element.isLight) {
                continue;
              }
              moodLeds.push(element);
            }
          }
        }

        var parent = scene.getObjectByName("Scene");

        if (parent != null) {
          parent.add(clonedMesh);
        } else {
          scene.add(clonedMesh);
        }

        extraOptionElement.object = clonedMesh;

        this.extraOptions.elements.push(extraOptionElement);
      }
    } else {
      // MOOD LIGHT
      for (let i = 0; i < count; i++) {
        const extraOptionElement = new PergolaExtraOptionElement();
        extraOptionElement.type = type;

        for (let j = 0; j < 4; j++) {
          const rectLight = new THREE.RectAreaLight(0xffffff, 1, 1, 0.05);
          rectLight.power = 3;
          rectLight.visible = false;

          // scene.add(new RectAreaLightHelper(rectLight)); //! TEMP for test

          const parent = scene.getObjectByName("Scene");
          if (parent != null) {
            parent.add(rectLight);
          } else {
            scene.add(rectLight);
          }

          extraOptionElement.objects[j] = rectLight;
        }
        this.extraOptions.elements.push(extraOptionElement);
      }
    }
  }

  prepareLouvereds() {
    const count = 209; // 629;
    this.cloneLouveredObject(count);
  }

  prepareBeams() {
    const count = 2;
    this.cloneBeamObject(PergolaRoofDirection.Straight, count + 1, false);
    this.cloneBeamObject(PergolaRoofDirection.Perpendicular, count, false);
    this.cloneBeamObject(PergolaRoofDirection.Straight, 17, true);
  }

  prepareFrames() {
    const count = 5; // 17;
    this.cloneFrameObject(count);
  }

  prepareExtraOptions() {
    const count_fan = 3; // 17;
    const count_heater = 7;
    const count_led = 5; // 17;
    const count_mood = 6; // 18;
    const count_mood_led = 5; // 17;
    const count_light = 103; // 320;

    this.cloneExtraOptionObject(PergolaExtraOptionType.heater, count_heater);
    this.cloneExtraOptionObject(PergolaExtraOptionType.led, count_led);
    this.cloneExtraOptionObject(PergolaExtraOptionType.moodLight, count_mood);
    this.cloneExtraOptionObject(PergolaExtraOptionType.moodLed, count_mood_led);
    this.cloneExtraOptionObject(PergolaExtraOptionType.light, count_light);
    this.cloneExtraOptionObject(PergolaExtraOptionType.fan, count_fan);

    const fanObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.fan
    );
    rotateFans(fanObjects, autoRotateSpeed);
  }

  async update() {
    this.changeDimensions(
      this.settings.width,
      this.settings.length,
      this.settings.height
    );

    if (
      this.lastSettings.roofLouveredRotate != this.settings.roofLouveredRotate
    ) {
      this.changeRoofLouveredRotate(this.settings.roofLouveredRotate);
    }

    // this.changePostSupport();
    this.changeBeamSupport();
    this.changeRoofFrame();
    this.changePostColor(this.settings.colorHex);
    this.changeLouverColor(this.settings.colorLouveredHex);
    // this.changeLedColor(this.settings.colorLedHex);
    // this.changeMoodLedColor(this.settings.colorMoodHex);
    this.changeMountingWall(
      this.settings.mountingWall_Back,
      this.settings.mountingWall_Left,
      this.settings.mountingWall_Right
    );

    if (this.lastSettings.color != this.settings.color) {
      this.lastSettings.color = this.settings.color;
    }

    this.changeExtraOptions();

    WriteURLParameters();
  }

  reset() {
    //this.changeDimensions(8, 8);
  }

  changeMountingWall(back, left, right, isPostsDepend = true) {
    this.changeMountingWallVisibility(back, PergolaElementOrientSide.Back);
    this.changeMountingWallVisibility(left, PergolaElementOrientSide.Left);
    this.changeMountingWallVisibility(right, PergolaElementOrientSide.Right);

    isPostsDepend && this.changePostVisibility(true, null, false);

    if (back) {
      this.changePostVisibility(false, PergolaPostSide.RL, false);
      this.changePostVisibility(false, PergolaPostSide.RR, false);
      this.changePostVisibility(false, PergolaPostSide.BC, true);
      this.lastSettings.mountingWall_Back = this.settings.mountingWall_Back;
    }

    if (left) {
      this.changePostVisibility(false, PergolaPostSide.RL, false);
      this.changePostVisibility(false, PergolaPostSide.FL, false);
      this.changePostVisibility(false, PergolaPostSide.LC, true);
      this.lastSettings.mountingWall_Left = this.settings.mountingWall_Left;
    }

    if (right) {
      this.changePostVisibility(false, PergolaPostSide.RR, false);
      this.changePostVisibility(false, PergolaPostSide.FR, false);
      this.changePostVisibility(false, PergolaPostSide.RC, true);
      this.lastSettings.mountingWall_Right = this.settings.mountingWall_Right;
    }
  }

  getAvaliableExtraLightObject(objects) {
    for (let index = 0; index < objects.length; index++) {
      const element = objects[index];
      if (element.active == true) {
        continue;
      }
      return element;
    }
  }

  getAvaliableObjectFromArray(objects) {
    for (let index = 0; index < objects.length; index++) {
      const element = objects[index];
      if (element.active == true) {
        continue;
      }
      return element;
    }
    return null;
  }

  // calculateExtraLightObjects(objects, mainPoints, pos1, pos2, dimension, interval = 7, numP = 0, useCenterMethod = false) {
  //   if (mainPoints.length > 0) {

  //     var mainPoints2 = generateMidpoints(pos1, pos2, Math.floor(dimension / 16), true);
  //     for (let i = 0; i < mainPoints2.length; i++) {

  //       if (i + 1 >= mainPoints2.length) { continue; }

  //       var point1 = mainPoints2[i];
  //       var point2 = mainPoints2[i + 1];
  //       var points = null;
  //       if (useCenterMethod == false) {
  //         points = generateMidpoints(point1, point2, numP <= 0 ? Math.floor(dimension / (mainPoints.length) / interval) : numP);
  //       } else {
  //         points = generateCenterMidpoints(point1, point2, numP <= 0 ? Math.floor(dimension / (mainPoints.length) / interval) : numP, true);
  //       }

  //       for (let w = 0; w < points.length; w++) {
  //         const point = points[w];
  //         const index = i * mainPoints2.length + w;

  //         if (index < objects.length) {
  //           const element = this.getAvaliableExtraLightObject(objects);

  //           element.object.position.x = point.x;

  //           switch (this.settings.postSize) {
  //             case PergolaPostType._4x4:
  //               element.object.position.y = 2.337;
  //               break;
  //             case PergolaPostType._7x7:
  //               element.object.position.y = 2.286;
  //               break;
  //             case PergolaPostType._8x8:
  //               element.object.position.y = 2.234;
  //               break;
  //             default:
  //               element.object.position.y = 2.286;
  //               break;
  //           }

  //           element.object.position.z = point.z;

  //           if (element.object.isGroup) {
  //             for (let index = 0; index < element.object.children.length; index++) {
  //               const obj = element.object.children[index];
  //               obj.visible = true;
  //             }
  //             element.object.visible = true;
  //             element.active = true;
  //           } else {
  //             element.object.visible = true;
  //             element.active = true;
  //           }
  //         } else {
  //           console.warn(`The element with index ${index} does not exist in the objects array.`);
  //         }
  //       }
  //     }
  //   } else {
  //     var points = generateMidpoints(pos1, pos2, Math.floor(dimension / interval));

  //     for (let w = 0; w < points.length; w++) {
  //       const point = points[w];

  //       const index = w;

  //       if (index < objects.length) {
  //         const element = this.getAvaliableExtraLightObject(objects);

  //         element.object.position.x = point.x;

  //         switch (this.settings.postSize) {
  //           case PergolaPostType._4x4:
  //             element.object.position.y = 2.337;
  //             break;
  //           case PergolaPostType._7x7:
  //             element.object.position.y = 2.286;
  //             break;
  //           case PergolaPostType._8x8:
  //             element.object.position.y = 2.234;
  //             break;
  //           default:
  //             element.object.position.y = 2.286;
  //             break;
  //         }

  //         element.object.position.z = point.z;

  //         if (element.object.isGroup) {
  //           for (let index = 0; index < element.object.children.length; index++) {
  //             const obj = element.object.children[index];
  //             obj.visible = true;
  //           }
  //           element.object.visible = true;
  //           element.active = true;
  //         } else {
  //           element.object.visible = true;
  //           element.active = true;
  //         }
  //       } else {
  //         console.warn(`The element with index ${index} does not exist in the objects array.`);
  //       }
  //     }
  //   }
  // }

  cloneMaterialTexture(name) {
    if (this.theModel == null) {
      return;
    }
    var mat = null;
    this.theModel.traverse((o) => {
      if (o.isMesh) {
        if (o.material.name == name) {
          mat = o.material;
          if (mat.map != null) {
            mat.map = mat.map.clone();
          }
        }
      }
    });
  }

  changeMaterialTilling(name, x, y) {
    if (this.theModel == null) {
      return;
    }
    var mat = null;
    this.theModel.traverse((o) => {
      if (o.isMesh) {
        if (o.material.name == name) {
          mat = o.material;
          if (mat.map != null) {
            mat.map.repeat.set(x, y);
          }
        }
      }
    });
  }

  changeMaterialOffset(name, x, y) {
    if (this.theModel == null) {
      return;
    }
    var mat = null;
    this.theModel.traverse((o) => {
      if (o.isMesh) {
        if (o.material.name == name) {
          mat = o.material;
          if (mat.map != null) {
            mat.map.offset.set(x, y);
          }
        }
      }
    });
  }

  changeExtraOptions() {
    const fanObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.fan
    );
    const heaterObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.heater
    );
    const fanBeams = this.roof.beams.filter((item) => item.isFanBeam === true);
    const lightObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.light
    );
    const ledObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.led
    );
    const moodLightObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.moodLight
    );
    const moodLedsObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.moodLed
    );

    this.changeObjectArrayVisibility(false, fanObjects);
    this.changeObjectArrayVisibility(false, heaterObjects);
    this.changeObjectArrayVisibility(false, fanBeams);
    this.changeObjectArrayVisibility(false, ledObjects);
    this.changeObjectArrayVisibility(false, moodLedsObjects);
    this.changeObjectArrayVisibility(false, lightObjects);
    this.changeMoodLightsVisibility(false, moodLightObjects);

    const { framesPoints } = this.getFramesPoints();

    //! FANS
    if (this.settings.extraOptionFan) {
      const { FL_point, FR_point, RL_point } = this.getCornerPoints();
      const { mainBeamQty, leftPoints, frontPoints } = this.getFramesPoints();
      const framesPerGap = (leftPoints.length - 1) / (mainBeamQty + 1);
      const delta = this.settings.beamThickness / framesPerGap;
      const frameWidth = frontPoints[0].distanceTo(frontPoints[1]);
      const frameLength = leftPoints[0].distanceTo(leftPoints[1]) - delta;

      let fanPoints = [];
      let addBeam = false;

      const horiFrameQty = Math.round(this.totalWidth / frameWidth);
      const vertFrameQty = Math.round(this.totalLength / frameLength);
      const vertPoints = generateMidpoints(
        FL_point,
        RL_point,
        vertFrameQty - 1
      );

      if (horiFrameQty > 1) {
        if (vertFrameQty >= 2) {
          const horiPoints = generateCenterMidpoints(
            FL_point,
            FR_point,
            horiFrameQty - 1,
            true
          );
          for (let i = 0; i < vertPoints.length; i++) {
            for (let j = 0; j < horiPoints.length; j++) {
              fanPoints.push(
                new THREE.Vector3(horiPoints[j].x, 0, vertPoints[i].z)
              );
            }
          }
          addBeam = false;
        } else {
          fanPoints.push(new THREE.Vector3(0, 0, 0));
          addBeam = false;
        }
      } else {
        if (vertFrameQty >= 2) {
          const horiPoints = generateMidpoints(
            FL_point,
            FR_point,
            horiFrameQty
          );
          for (let i = 0; i < vertPoints.length; i++) {
            for (let j = 0; j < horiPoints.length; j++) {
              fanPoints.push(
                new THREE.Vector3(horiPoints[j].x, 0, vertPoints[i].z)
              );
            }
          }
          addBeam = false;
        } else {
          fanPoints.push(new THREE.Vector3(0, 0, 0));
          addBeam = true;
        }
      }

      for (let index = 0; index < fanPoints.length; index++) {
        const point = fanPoints[index];

        const fan = this.getAvaliableObjectFromArray(fanObjects);
        fan.object.position.x = point.x;
        fan.object.position.z = point.z;
        this.changeObjectVisibility(true, fan.object);
        fan.active = true;

        if (addBeam) {
          const fanBeam = this.getAvaliableObjectFromArray(fanBeams);
          fanBeam.object.position.x = point.x;
          fanBeam.object.position.z = point.z;
          this.changeObjectVisibility(true, fanBeam.object);
          fanBeam.active = true;
        }
      }

      this.lastSettings.extraOptionLight = this.settings.extraOptionLight;
    }

    //! MOOD LIGHTS
    if (this.settings.extraOptionMoodLight) {
      if (framesPoints.length === 1) {
        this.changeMoodLightParameters(
          moodLightObjects,
          this.settings.colorMoodHex
        );
      } else {
        for (let index = 0; index < framesPoints.length; index++) {
          const point = framesPoints[index];
          const moodLedStrip =
            this.getAvaliableObjectFromArray(moodLedsObjects);
          moodLedStrip.object.position.x = point.x;
          moodLedStrip.object.position.z = point.z;
          moodLedStrip.object.position.y = 0;
          this.changeObjectVisibility(true, moodLedStrip.object);
          moodLedStrip.active = true;
        }
      }
    }

    //! HEATERS
    if (this.settings.extraOptionHeaters) {
      const { FL_point, FR_point, RL_point, RR_point } = this.getCornerPoints();
      const heaterOffset = 0.2;
      const heaterHight = this.totalHeight - 0.3;

      FL_point.x += heaterOffset;
      FL_point.y = heaterHight;
      FL_point.z -= heaterOffset;
      FR_point.x -= heaterOffset;
      FR_point.y = heaterHight;
      FR_point.z -= heaterOffset;
      RL_point.x += heaterOffset;
      RL_point.y = heaterHight;
      RL_point.z += heaterOffset;
      RR_point.x -= heaterOffset;
      RR_point.y = heaterHight;
      RR_point.z += heaterOffset;

      let leftPoints = [];
      let rightPoints = [];
      let frontPoints = [];
      let rearPoints = [];

      if (this.dimensions.length > this.settings.postLengthInterval) {
        leftPoints = generateMidpoints(FL_point, RL_point, 3, false);
        rightPoints = generateMidpoints(FR_point, RR_point, 3, false);
        leftPoints.splice(1, 1);
        rightPoints.splice(1, 1);
      } else {
        leftPoints = generateMidpoints(FL_point, RL_point, 1, false);
        rightPoints = generateMidpoints(FR_point, RR_point, 1, false);
      }

      if (this.dimensions.width > this.settings.postWidthInterval) {
        frontPoints = generateMidpoints(FL_point, FR_point, 3, false);
        rearPoints = generateMidpoints(RL_point, RR_point, 3, false);
        frontPoints.splice(1, 1);
        rearPoints.splice(1, 1);
      } else {
        frontPoints = generateMidpoints(FL_point, FR_point, 1, false);
        rearPoints = generateMidpoints(RL_point, RR_point, 1, false);
      }

      function setHeaters(points, rotationAngle) {
        points.forEach((point) => {
          const heater = this.getAvaliableObjectFromArray(heaterObjects);
          heater.object.position.set(point.x, point.y, point.z);
          heater.object.rotation.y = THREE.MathUtils.degToRad(rotationAngle);
          this.changeObjectVisibility(true, heater.object);
          heater.active = true;
        });
      }

      setHeaters.call(this, leftPoints, 90);
      setHeaters.call(this, rightPoints, -90);
      setHeaters.call(this, frontPoints, 180);
      setHeaters.call(this, rearPoints, 0);

      // this.lastSettings.extraOptionLight = this.settings.extraOptionLight;
    }

    //! LED STRIPS
    if (this.settings.extraOptionLed) {
      for (let index = 0; index < framesPoints.length; index++) {
        const point = framesPoints[index];
        const ledStrip = this.getAvaliableObjectFromArray(ledObjects);
        // console.log("🚀 ~ ledStrip:", ledStrip);
        ledStrip.object.position.x = point.x;
        ledStrip.object.position.z = point.z;
        this.changeObjectVisibility(true, ledStrip.object);
        ledStrip.active = true;
      }
    }

    //! POINTLIGHTS
    if (this.settings.extraOptionLight) {
      const minLightQty = this.getPointLightpositions(8).length;
      const maxLightQty = this.getPointLightpositions(2).length;

      const lightGap = this.settings.extraOptionLightSpacing;

      const lightPoints = this.getPointLightpositions(lightGap);
      const pointY = 2.185;

      for (let i = 0; i < lightPoints.length; i++) {
        const element = lightObjects[i];
        const light = element.object;
        light.position.set(lightPoints[i].x, pointY, lightPoints[i].z);
        // light.children[1].material.emissiveIntensity = 3;
        element.active = true;
        this.changeObjectVisibility(true, light);
      }

      this.lastSettings.extraOptionFan = this.settings.extraOptionFan;
    }
  }

  changeDimensions(width = null, length = null, height = null) {
    switch (this.settings.postSize) {
      case PergolaPostType._4x4:
        ChangeGlobalMorph('4"-7"', 0);
        break;
      case PergolaPostType._7x7:
        ChangeGlobalMorph('4"-7"', 1);
        break;
      default:
        break;
    }

    let valueTillingX = 1;
    let valueTillingY = 1;
    let valueTillingZ = 1;

    if (height != null) {
      this.dimensions.height = height;

      const targetValue = ConvertMorphValue(
        height,
        MORPH_DATA.height.min,
        MORPH_DATA.height.max
      );
      valueTillingY = targetValue;
      this.totalHeight = ConvertMorphValueReverse(
        targetValue,
        MORPH_DATA_SI.height.min,
        MORPH_DATA_SI.height.max,
        0,
        1
      );

      ChangeGlobalMorph("height", targetValue);

      pergolaSettings.width = width;
      this.lastSettings.width = this.settings.width;
    }

    if (width != null) {
      this.dimensions.width = width;

      const targetValue = ConvertMorphValue(
        width,
        MORPH_DATA.width.min,
        MORPH_DATA.width.max
      );
      valueTillingX = targetValue;
      // 0.09 => товщина контурної рами;
      this.totalWidth =
        ConvertMorphValueReverse(
          targetValue,
          MORPH_DATA_SI.width.min,
          MORPH_DATA_SI.width.max,
          0,
          1
        ) - 0.09;

      ChangeGlobalMorph("width", targetValue);
      ChangeGlobalMorph("width_wall", targetValue);

      pergolaSettings.width = width;
      this.lastSettings.width = this.settings.width;
    }

    if (length != null) {
      this.dimensions.length = length;

      const targetValue = ConvertMorphValue(
        length,
        MORPH_DATA.length.min,
        MORPH_DATA.length.max
      );
      valueTillingZ = targetValue;
      // 0.09 => товщина контурної рами;
      this.totalLength =
        ConvertMorphValueReverse(
          targetValue,
          MORPH_DATA_SI.length.min,
          MORPH_DATA_SI.length.max,
          0,
          1
        ) - 0.09;

      ChangeGlobalMorph("length", targetValue);
      ChangeGlobalMorph("length_wall", targetValue);

      pergolaSettings.length = length;
      this.lastSettings.length = this.settings.length;
    }

    if (length != null && width != null && height != null) {
      this.updateWallTilling(
        height,
        valueTillingX,
        valueTillingY,
        valueTillingZ
      );
    }
  }

  updateWallTilling(height, valueX, valueY, valueZ) {
    let wallBackTillingX = ConvertMorphValueReverse(
      valueX,
      1,
      9,
      0,
      0.6296296296296297
    );
    let wallSideTillingZ = ConvertMorphValueReverse(
      valueZ,
      1,
      5,
      0,
      0.6296296296296297
    );

    const wallSideTillingY = ConvertMorphValueReverse(valueY, 1, 1.703, 0, 1);
    const wallBackTillingY = ConvertMorphValueReverse(valueY, 1, 3.34, 0, 1);

    this.changeMaterialTilling("wall_side", wallSideTillingZ, wallSideTillingY);
    this.changeMaterialOffset(
      "wall_side",
      0.0,
      WALL_OFFSETS[`height_${height}`].sideWallOffsetY
    );

    this.changeMaterialTilling("wall_tile", wallBackTillingX, wallBackTillingY);
    this.changeMaterialOffset(
      "wall_tile",
      0.0,
      WALL_OFFSETS[`height_${height}`].backWallOffsetY
    );
  }

  changePostSupport() {
    this.changePostVisibility(false, null, true);
    const FC_Post = this.getPostObject(null, PergolaPostSide.FC);
    const BC_Post = this.getPostObject(null, PergolaPostSide.BC);
    const LC_Post = this.getPostObject(null, PergolaPostSide.LC);
    const RC_Post = this.getPostObject(null, PergolaPostSide.RC);
    const CC_Post = this.getPostObject(null, PergolaPostSide.CC);

    if (this.dimensions.width > this.settings.postWidthInterval) {
      FC_Post.visible = true;
      BC_Post.visible = true;
    } else {
      FC_Post.visible = false;
      BC_Post.visible = false;
    }

    if (this.dimensions.length > this.settings.postLengthInterval) {
      LC_Post.visible = true;
      RC_Post.visible = true;
    } else {
      LC_Post.visible = false;
      RC_Post.visible = false;
    }

    if (
      this.dimensions.width > this.settings.postWidthInterval &&
      this.dimensions.length > this.settings.postLengthInterval
    ) {
      CC_Post.visible = true;
    } else {
      CC_Post.visible = false;
    }
  }

  changeBeamSupport() {
    this.changeBeamVisibility(false, null, null);

    const { FL_point, FR_point, RL_point } = this.getCornerPoints();

    const leftPoints = generateMidpoints(
      RL_point,
      FL_point,
      Math.floor(this.dimensions.length / this.settings.beamLengthInterval)
    );
    const frontPoints = generateMidpoints(
      FL_point,
      FR_point,
      Math.floor(this.dimensions.width / this.settings.beamWidthInterval)
    );

    if (this.dimensions.length > this.settings.beamPerimeterInterval) {
      const pointL = FL_point.clone();
      const pointR = FR_point.clone();
      pointL.x -= this.settings.beamThickness / 2;
      pointR.x += this.settings.beamThickness / 2;
      frontPoints.push(pointL, pointR);
    }

    if (this.dimensions.width > this.settings.beamPerimeterInterval) {
      leftPoints.push(RL_point, FL_point);
    }

    //* LEFT
    if (leftPoints.length > 0) {
      this.changeSupportBeamPositions(
        PergolaRoofDirection.Straight,
        leftPoints,
        null,
        0
      );
    }

    //* FRONT
    if (frontPoints.length > 0) {
      this.changeSupportBeamPositions(
        PergolaRoofDirection.Perpendicular,
        frontPoints,
        0,
        null
      );
    }
  }

  changeSupportBeamPositions(
    direction,
    points,
    x = null,
    y = null,
    height = null
  ) {
    const beams = this.roof.beams.filter(
      (item) => item.direction == direction && item.isFanBeam === false
    );

    for (let index = 0; index < points.length; index++) {
      const point = points[index];
      const element = this.getAvaliableObjectFromArray(beams);

      element.object.position.x = y == null ? point.x : y;

      if (height != null) {
        element.object.position.y = height;
      }

      element.object.position.z = x == null ? point.z : x;
      element.object.visible = true;
      element.active = true;
    }
  }

  changeMoodLightParameters(moodLightObjects, color) {
    const { mainBeamQty, leftPoints, frontPoints, framesPoints } =
      this.getFramesPoints();
    const framesPerGap = (leftPoints.length - 1) / (mainBeamQty + 1);
    const delta = this.settings.beamThickness / framesPerGap;
    const frameWidth = frontPoints[0].distanceTo(frontPoints[1]);
    const frameLength = leftPoints[0].distanceTo(leftPoints[1]) - delta;
    const moodOffset = 0.04;

    for (let i = 0; i < framesPoints.length; i++) {
      const element = moodLightObjects[i];

      for (let j = 0; j < element.objects.length; j++) {
        const light = element.objects[j];
        light.color = new THREE.Color(color);
        light.position.y = this.totalHeight - 0.2;

        if (j == 0) {
          light.position.x = framesPoints[i].x;
          light.position.z = framesPoints[i].z - frameLength / 2 + moodOffset;
          light.width = frameWidth - moodOffset * 2;
          light.rotation.y = THREE.MathUtils.degToRad(180);
          light.visible = frameLength < frameWidth;
        } else if (j == 1) {
          light.position.x = framesPoints[i].x + frameWidth / 2 - moodOffset;
          light.position.z = framesPoints[i].z;
          light.width = frameLength - moodOffset * 2;
          light.rotation.y = THREE.MathUtils.degToRad(90);
          light.visible = frameLength >= frameWidth;
        } else if (j == 2) {
          light.position.x = framesPoints[i].x;
          light.position.z = framesPoints[i].z + frameLength / 2 - moodOffset;
          light.width = frameWidth - moodOffset * 2;
          light.visible = frameLength < frameWidth;
        } else if (j == 3) {
          light.position.x = framesPoints[i].x - frameWidth / 2 + moodOffset;
          light.position.z = framesPoints[i].z;
          light.width = frameLength - moodOffset * 2;
          light.rotation.y = THREE.MathUtils.degToRad(-90);
          light.visible = frameLength >= frameWidth;
        }
      }
    }
  }

  getPointLightpositions(lightGap) {
    const { FL_point, FR_point, RL_point, RR_point } = this.getCornerPoints();
    const { mainBeamQty, leftPoints, frontPoints } = this.getFramesPoints();
    const framesPerGap = (leftPoints.length - 1) / (mainBeamQty + 1);
    const delta = this.settings.beamThickness / framesPerGap;
    const frameWidth = frontPoints[0].distanceTo(frontPoints[1]);
    const frameLength = leftPoints[0].distanceTo(leftPoints[1]) - delta;

    // const pointY = 2.45; // for testing
    const postOffset = 0.04;

    // Perimeter beams

    function calculatePerimeterPostPoints(
      startPoint,
      endPoint,
      dimensionValue,
      postInterval
    ) {
      if (dimensionValue > postInterval) {
        const q = Math.floor(dimensionValue / postInterval);
        return generateMidpoints(startPoint, endPoint, q, true);
      } else {
        return [startPoint, endPoint];
      }
    }

    const FLRL_postPoints = this.settings.mountingWall_Left
      ? []
      : calculatePerimeterPostPoints(
        FL_point,
        RL_point,
        this.dimensions.length,
        this.settings.postLengthInterval
      );
    const FLFR_postPoints = calculatePerimeterPostPoints(
      FL_point,
      FR_point,
      this.dimensions.width,
      this.settings.postWidthInterval
    );
    const FRRR_postPoints = this.settings.mountingWall_Right
      ? []
      : calculatePerimeterPostPoints(
        FR_point,
        RR_point,
        this.dimensions.length,
        this.settings.postLengthInterval
      );
    const RLRR_postPoints = this.settings.mountingWall_Back
      ? []
      : calculatePerimeterPostPoints(
        RL_point,
        RR_point,
        this.dimensions.width,
        this.settings.postWidthInterval
      );

    function calculatePointsBetweenPosts(postPoints, gap) {
      const points = [];
      if (postPoints.length <= 1) {
        return points;
      }

      for (let i = 0; i < postPoints.length - 1; i++) {
        let qty =
          Math.round(
            postPoints[i].distanceTo(postPoints[i + 1]) / (gap * 0.3048)
          ) - 1;
        if (qty < 1) {
          qty = 1;
        }
        points.push(
          generateMidpoints(postPoints[i], postPoints[i + 1], qty, false)
        );
      }

      return points;
    }

    let FLRL_points = calculatePointsBetweenPosts(
      FLRL_postPoints,
      lightGap
    ).flat();
    let FLFR_points = calculatePointsBetweenPosts(
      FLFR_postPoints,
      lightGap
    ).flat();
    let FRRR_points = calculatePointsBetweenPosts(
      FRRR_postPoints,
      lightGap
    ).flat();
    let RLRR_points = calculatePointsBetweenPosts(
      RLRR_postPoints,
      lightGap
    ).flat();

    setValueToCoordinates(FLRL_points, "x", FL_point.x + postOffset);
    setValueToCoordinates(FLFR_points, "z", FL_point.z - postOffset);
    setValueToCoordinates(FRRR_points, "x", FR_point.x - postOffset);
    setValueToCoordinates(RLRR_points, "z", RL_point.z + postOffset);

    const perimeterLightPoints = [
      ...FLRL_points,
      ...FLFR_points,
      ...FRRR_points,
      ...RLRR_points,
    ].flat();

    const vertCrossQty = Math.round(this.totalLength / frameLength) - 1;
    const horiCrossQty = Math.round(this.totalWidth / frameWidth) - 1;
    const vertCrossPoints = generateMidpoints(
      FL_point,
      RL_point,
      vertCrossQty,
      true
    );
    const horiCrossPoints = generateMidpoints(
      FL_point,
      FR_point,
      horiCrossQty,
      true
    );

    if (
      this.dimensions.width > this.settings.postWidthInterval &&
      this.dimensions.length > this.settings.postLengthInterval
    ) {
      if (vertCrossPoints.length % 2 === 0) {
        const middleIndex = vertCrossPoints.length / 2;
        vertCrossPoints.splice(middleIndex, 0, new THREE.Vector3(0, 0, 0));
      }
    }

    // Vertical beams
    let vertLightPoints = [];
    for (let i = 1; i < horiCrossPoints.length - 1; i++) {
      if (horiCrossPoints.length <= 2) {
        break;
      }
      setValueToCoordinates(vertCrossPoints, "x", horiCrossPoints[i].x);
      vertLightPoints.push(
        ...calculatePointsBetweenPosts(vertCrossPoints, lightGap)
      );
    }

    // Horisontal beams
    let horiLightPoints = [];

    if (
      this.dimensions.width > this.settings.postWidthInterval &&
      this.dimensions.length > this.settings.postLengthInterval
    ) {
      if (vertCrossPoints.length % 2 !== 0) {
        const middleIndex = Math.floor(vertCrossPoints.length / 2);
        vertCrossPoints.splice(middleIndex, 1);
      }
    }

    for (let i = 1; i < vertCrossPoints.length - 1; i++) {
      if (vertCrossPoints.length <= 2) {
        break;
      }
      setValueToCoordinates(horiCrossPoints, "z", vertCrossPoints[i].z);
      horiLightPoints.push(
        ...calculatePointsBetweenPosts(horiCrossPoints, lightGap)
      );
    }

    const allLightPoints = [
      ...perimeterLightPoints,
      ...vertLightPoints,
      ...horiLightPoints,
    ].flat();

    return allLightPoints;
  }

  getCornerPoints() {
    let offsetX = 0;
    let offsetZ = this.settings.beamThickness;

    if (this.dimensions.length > this.settings.beamPerimeterInterval) {
      offsetX = offsetX - this.settings.beamThickness * 2; //! for vertical side beams
    }

    if (this.dimensions.width > this.settings.beamPerimeterInterval) {
      offsetZ = offsetZ - this.settings.beamThickness * 2; //! for vertical side beams
    }

    const RL_point = new THREE.Vector3(
      -this.totalWidth / 2 - offsetX / 2,
      0,
      -this.totalLength / 2 - offsetZ / 2
    );
    const FL_point = new THREE.Vector3(
      -this.totalWidth / 2 - offsetX / 2,
      0,
      this.totalLength / 2 + offsetZ / 2
    );
    const FR_point = new THREE.Vector3(
      this.totalWidth / 2 + offsetX / 2,
      0,
      this.totalLength / 2 + offsetZ / 2
    );
    const RR_point = new THREE.Vector3(
      this.totalWidth / 2 + offsetX / 2,
      0,
      -this.totalLength / 2 - offsetZ / 2
    );

    return { FL_point, FR_point, RL_point, RR_point };
  }

  getFramesPoints() {
    const { FL_point, FR_point, RL_point } = this.getCornerPoints();

    let pointsQty = Math.floor(
      this.dimensions.length / this.settings.beamLengthInterval
    );
    const gapsQty = pointsQty + 1;
    const gapLength = this.dimensions.length / gapsQty;
    const mainBeamQty = gapsQty - 1;

    if (gapLength > this.settings.beamLouverLengthInterval) {
      pointsQty =
        pointsQty +
        Math.floor(gapLength / this.settings.beamLouverLengthInterval) *
        gapsQty;
    }

    let leftPoints = generateMidpoints(FL_point, RL_point, pointsQty, true);
    let leftCenterPoints = generateCenterMidpoints(
      FL_point,
      RL_point,
      pointsQty,
      true
    );

    const framesPerGap = (leftPoints.length - 1) / (mainBeamQty + 1);
    const adjustmentValue = this.settings.beamThickness / 4;

    if (framesPerGap == 2 && leftCenterPoints.length % 2 === 0) {
      for (let i = 0; i < leftCenterPoints.length; i += 2) {
        leftCenterPoints[i].z -= adjustmentValue;
        leftCenterPoints[i + 1].z += adjustmentValue;
      }
    }

    const frontPoints = generateMidpoints(
      FL_point,
      FR_point,
      Math.floor(this.dimensions.width / this.settings.beamWidthInterval),
      true
    );
    const frontCenterPoints = generateCenterMidpoints(
      FL_point,
      FR_point,
      Math.floor(this.dimensions.width / this.settings.beamWidthInterval),
      true
    );

    let framesPoints = [];

    for (let i = 0; i < leftCenterPoints.length; i++) {
      for (let j = 0; j < frontCenterPoints.length; j++) {
        const point = new THREE.Vector3(
          frontCenterPoints[j].x,
          0,
          leftCenterPoints[i].z
        );
        framesPoints.push(point);
      }
    }

    return { mainBeamQty, leftPoints, frontPoints, framesPoints };
  }

  changeRoofFrame() {
    this.changeRoofFrameVisibility(false);

    const { mainBeamQty, leftPoints, frontPoints, framesPoints } =
      this.getFramesPoints();

    const framesPerGap = (leftPoints.length - 1) / (mainBeamQty + 1);
    const delta = this.settings.beamThickness / framesPerGap;
    const frameWidth = frontPoints[0].distanceTo(frontPoints[1]);
    const frameLength = leftPoints[0].distanceTo(leftPoints[1]) - delta;

    // this.changeFramePosition(framesPoints);

    const targetValueLength = ConvertMorphValue(
      frameLength,
      MORPH_DATA_SI.frameLength.min,
      MORPH_DATA_SI.frameLength.max
    );
    const targetValueWidth = ConvertMorphValue(
      frameWidth,
      MORPH_DATA_SI.frameWidth.min,
      MORPH_DATA_SI.frameWidth.max
    );

    ChangeGlobalMorph("length_louver", targetValueLength);
    ChangeGlobalMorph("width_louver", targetValueWidth);

    this.changeLouvers(frameWidth, framesPoints);
  }

  changeFramePosition(points, x = null, y = null, height = null) {
    const frames = this.roof.frames;

    for (let index = 0; index < points.length; index++) {
      const point = points[index];
      const element = this.getAvaliableObjectFromArray(frames);

      element.object.position.x = y == null ? point.x : y;
      if (height != null) {
        element.object.position.y = height;
      }
      element.object.position.z = x == null ? point.z : x;

      this.changeObjectVisibility(true, element.object);
      element.active = true;
    }
  }

  changeLouvers(frameWidth, framesPoints) {
    this.changeLouversVisibility(false);

    // const louverWidth = 0.17989;
    const louverWidth = 0.1677;
    const firstLouverOffset = 0.15;
    const louverQtyPerFrame =
      (frameWidth - firstLouverOffset + 0.03) / louverWidth;
    const louverQtyPerFrameRound = Math.floor(louverQtyPerFrame);
    const delta = louverQtyPerFrame - louverQtyPerFrameRound;
    const coveredWidth = louverQtyPerFrameRound * louverWidth;

    let loversPoints = [];

    for (let i = 0; i < framesPoints.length; i++) {
      let louverPointX =
        delta >= 0.5
          ? framesPoints[i].x - coveredWidth / 2 + 0.06
          : framesPoints[i].x - frameWidth / 2 + firstLouverOffset;

      const louverPointZ = framesPoints[i].z;

      for (let j = 0; j < louverQtyPerFrameRound; j++) {
        const point = new THREE.Vector3(louverPointX, 0, louverPointZ);
        loversPoints.push(point);
        louverPointX += louverWidth;
      }
    }

    const louverHeight = this.totalHeight - 0.125;
    this.changeLouversPosition(loversPoints, louverHeight);
  }

  changeLouversPosition(points, height = null, x = null, y = null) {
    const louvers = this.roof.louvered.objects;

    for (let index = 0; index < points.length; index++) {
      const point = points[index];
      const element = this.getAvaliableObjectFromArray(louvers);

      element.object.position.x = y == null ? point.x : y;
      if (height != null) {
        element.object.position.y = height;
      }
      element.object.position.z = x == null ? point.z : x;

      this.changeObjectVisibility(true, element.object);
      element.active = true;
    }
  }

  changeRoofLouveredRotate(value) {
    if (value == null) return;

    for (let index = 0; index < this.roof.louvered.objects.length; index++) {
      const element = this.roof.louvered.objects[index];
      element.object.rotation.z = THREE.MathUtils.degToRad(value);
    }

    this.lastSettings.roofLouveredRotate = this.settings.roofLouveredRotate;
  }

  changePostColor(value) {
    if (value == null) {
      return;
    }

    for (let index = 0; index < this.post.objects.length; index++) {
      const element = this.post.objects[index];
      element.object.material.color.set(value);
      setMaterialColor("alum", value);
    }
  }

  changeLouverColor(value) {
    if (value == null) {
      return;
    }

    for (let index = 0; index < this.roof.louvered.objects.length; index++) {
      const element = this.roof.louvered.objects[index];
      element.object.material.color.set(value);
    }
  }

  changeLedColor(value) {
    if (value == null) {
      return;
    }

    const ledObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.led
    );

    ledObjects[0].object.material.color.set(value);
    ledObjects[0].object.material.emissive.set(value);
    // ledObjects[0].object.material.emissiveIntensity = 5;
  }

  changeMoodLedColor(value) {
    if (value == null) {
      return;
    }

    const moodLedObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.moodLed
    );

    moodLedObjects[0].object.material.color.set(value);
    moodLedObjects[0].object.material.emissive.set(value);
    // moodLedObjects[0].object.material.emissiveIntensity = 5;
  }

  getPostObject(name = null, postSide = null, isLock = null, isSupport = null) {
    if (this.post == null) {
      return;
    }
    if (this.post.objects == null) {
      return;
    }

    for (let index = 0; index < this.post.objects.length; index++) {
      const element = this.post.objects[index];

      if (name != null) {
        if (element.name != name) {
          continue;
        }
      }

      if (postSide != null) {
        if (element.side != postSide) {
          continue;
        }
      }

      if (isLock != null) {
        if (element.isLock != isLock) {
          continue;
        }
      }

      if (isSupport != null) {
        if (element.isSupport != isSupport) {
          continue;
        }
      }

      return element.object;
    }
  }

  changeRoofFrameVisibility(status, frameType = null) {
    if (this.roof == null) {
      return;
    }
    if (this.roof.frames == null) {
      return;
    }

    for (let index = 0; index < this.roof.frames.length; index++) {
      const element = this.roof.frames[index];

      if (frameType != null) {
        if (element.type != frameType) {
          continue;
        }
      }

      if (element.object.isGroup) {
        for (let index = 0; index < element.object.children.length; index++) {
          const ge = element.object.children[index];
          ge.visible = status;
        }
      } else {
        element.object.visible = status;
      }

      element.active = status;
    }
  }

  changeLouversVisibility(status) {
    if (this.roof == null) {
      return;
    }
    if (this.roof.louvered == null) {
      return;
    }
    if (this.roof.louvered.objects == null) {
      return;
    }

    for (let index = 0; index < this.roof.louvered.objects.length; index++) {
      const element = this.roof.louvered.objects[index];

      if (element.object.isGroup) {
        for (let index = 0; index < element.object.children.length; index++) {
          const ge = element.object.children[index];
          ge.visible = status;
        }
      } else {
        element.object.visible = status;
      }

      element.active = status;
    }
  }

  changeObjectVisibility(status, object) {
    if (object == null) {
      return;
    }

    object.visible = status;

    if (object.isGroup) {
      for (let index = 0; index < object.children.length; index++) {
        const ge = object.children[index];
        ge.visible = status;
      }
    }
  }

  changeMoodLightVisibility(status, element) {
    if (element == null) {
      return;
    }

    for (let i = 0; i < element.objects.length; i++) {
      element.objects[i].visible = status;

      if (element.objects[i].isGroup) {
        for (
          let index = 0;
          index < element.objects[i].children.length;
          index++
        ) {
          const ge = element.objects[i].children[index];
          ge.visible = status;
        }
      }
    }
  }

  changeObjectArrayVisibility(status, objectArray) {
    if (objectArray == null || objectArray.length == 0) {
      return;
    }

    for (let f = 0; f < objectArray.length; f++) {
      const element = objectArray[f];
      if (element.object.isGroup) {
        for (let index = 0; index < element.object.children.length; index++) {
          const obj = element.object.children[index];
          obj.visible = status;
        }
        element.object.visible = status;
        element.active = status;
      } else {
        element.object.visible = status;
        element.active = status;
      }
    }
  }

  changeMoodLightsVisibility(status, objectArray) {
    if (objectArray == null || objectArray.length == 0) {
      return;
    }

    for (let f = 0; f < objectArray.length; f++) {
      const element = objectArray[f];
      for (let i = 0; i < element.objects.length; i++) {
        if (element.objects[i].isGroup) {
          for (
            let index = 0;
            index < element.objects[i].children.length;
            index++
          ) {
            const obj = element.objects[i].children[index];
            obj.visible = status;
          }
          element.objects[i].visible = status;
          element.active = status;
        } else {
          element.objects[i].visible = status;
          element.active = status;
        }
      }
    }
  }

  changePostVisibility(status, postSide = null, isSupport = null) {
    if (this.post == null) {
      return;
    }
    if (this.post.objects == null) {
      return;
    }

    for (let index = 0; index < this.post.objects.length; index++) {
      const element = this.post.objects[index];

      if (postSide != null) {
        if (element.side != postSide) {
          continue;
        }
      }

      if (element.isLock) {
        continue;
      }

      if (isSupport != null) {
        if (element.isSupport != isSupport) {
          continue;
        }
      }

      if (element.object.isGroup) {
        for (let index = 0; index < element.object.children.length; index++) {
          const ge = element.object.children[index];
          ge.visible = status;
        }
      } else {
        element.object.visible = status;
      }
    }
  }

  changeBeamVisibility(status, postType = null, postSide = null) {
    if (this.roof == null) {
      return;
    }
    if (this.roof.beams == null) {
      return;
    }

    for (let index = 0; index < this.roof.beams.length; index++) {
      const element = this.roof.beams[index];

      if (postType != null) {
        if (element.type != postType) {
          continue;
        }
      }

      if (postSide != null) {
        if (element.side != postSide) {
          continue;
        }
      }

      if (element.object.isGroup) {
        for (let index = 0; index < element.object.children.length; index++) {
          const ge = element.object.children[index];
          ge.visible = status;
        }
        element.object.visible = status;
        element.active = status;
      } else {
        element.object.visible = status;
        element.active = status;
      }
    }
  }

  changeMountingWallVisibility(status, side = null) {
    if (this.mountingWall == null) {
      return;
    }
    if (this.mountingWall.elements == null) {
      return;
    }

    for (let index = 0; index < this.mountingWall.elements.length; index++) {
      const element = this.mountingWall.elements[index];

      if (side != null) {
        if (element.side != side) {
          continue;
        }
      }

      if (element.object.isGroup) {
        for (let index = 0; index < element.object.children.length; index++) {
          const ge = element.object.children[index];
          ge.visible = status;
        }
      } else {
        element.object.visible = status;
      }
    }
  }
}

export class PergolaSettings {
  constructor() {
    this.width = null;
    this.length = null;
    this.height = null;
    this.postSize = null;
    this.postWidthInterval = null;
    this.postLengthInterval = null;
    this.color = 0;
    this.colorHex = null;
    this.colorLouvered = 0;
    this.colorLouveredHex = null;
    this.colorLedHex = null;
    this.colorMoodHex = null;
    this.colors = null;
    this.colorsLouvered = null;
    this.roofLouveredRotate = 0;
    this.roofColor = null;
    this.mountingWall_Back = false;
    this.mountingWall_Left = false;
    this.mountingWall_Right = false;
    this.extraOptionLight = null;
    this.extraOptionLightSpacing = null;
    this.extraOptionFan = null;
    this.extraOptionLed = null;
    this.extraOptionHeaters = null;
    this.extraOptionMoodLight = null;
  }

  getValues() {
    var values = [
      {
        name: "Dimensions",
        value: pergolaSettings.toString_dimensions(),
        options: null,
      },
      {
        name: "Frame Color",
        value: pergolaSettings.toString_color(),
        options: null,
      },
      {
        name: "Louver Color",
        value: pergolaSettings.toString_louverColor(),
        options: null,
      },
      {
        name: "Post size",
        value: pergolaSettings.toString_postSize(),
        options: null,
      },
      {
        name: "Wall Mounted",
        value: pergolaSettings.toString_mountingWall(),
        options: null,
      },
      {
        name: "Side Options",
        value: "",
        options: [
          ["Recessed lighting", pergolaSettings.toString_extraOptions_Light()],
          ["Led lights", pergolaSettings.toString_extraOptions_Led()],
          ["Mood lighting", pergolaSettings.toString_extraOptions_Mood()],
          ["Ceiling fan", pergolaSettings.toString_extraOptions_Fan()],
          ["Heaters", pergolaSettings.toString_extraOptions_Heater()],
        ],
      },
    ];

    return values;
  }

  toString_dimensions() {
    return `Width: ${this.width}', Projection:${this.length}', Height: ${this.height}'`;
  }

  toString_color() {
    return this.colorHex.toUpperCase();
  }

  toString_louverColor() {
    return this.colorLouveredHex.toUpperCase();
  }

  toString_postSize() {
    switch (this.postSize) {
      case PergolaPostType._4x4:
        return '4"x4"';
      case PergolaPostType._7x7:
        return '7"x7"';
      default:
        return "";
    }
  }

  toString_mountingWall() {
    let array = [];

    if (this.mountingWall_Back == true) {
      array.push("Back Side");
    }
    if (this.mountingWall_Left == true) {
      array.push("Left Side");
    }
    if (this.mountingWall_Right == true) {
      array.push("Right Side");
    }

    if (array.length == 1) {
      return array[0];
    }

    let result = "";

    for (let index = 0; index < array.length; index++) {
      result += array[index];

      if (index != array.length - 1) {
        result += ", ";
      }
    }

    return result;
  }

  toString_extraOptions_Light() {
    return this.extraOptionLight == true
      ? `Yes (Spacing: ${this.extraOptionLightSpacing}')`
      : "No";
  }

  toString_extraOptions_Fan() {
    return this.extraOptionFan == true ? "Yes" : "No";
  }

  toString_extraOptions_Led() {
    return this.extraOptionLed == true
      ? `Yes (${this.colorLedHex.toUpperCase()})`
      : "No";
  }

  toString_extraOptions_Mood() {
    return this.extraOptionMoodLight == true
      ? `Yes (${this.colorMoodHex.toUpperCase()})`
      : "No";
  }

  toString_extraOptions_Heater() {
    return this.extraOptionHeaters == true ? "Yes" : "No";
  }
}

// Типи перголи
// const PergolaType = {
//   Cantilever: 0,
//   Freestanding: 1,
//   Attached: 2
// };

// Клас для розмірів перголи
class PergolaDimensions {
  constructor() {
    this.width = 8; // ширина в футах
    this.length = 8; // довжина в футах
    this.height = 8; // висота в футах
  }
}

// Клас для постів перголи
class PergolaPost {
  constructor() {
    this.objects = [];
  }
}

class PergolaPostObject {
  constructor() {
    this.name = "";
    this.type = null;
    this.isSupport = false;
    this.isLock = false;
    this.side = null;
    this.object = null;
    this.active = false;
  }
}

const PergolaPostType = {
  _4x4: 0,
  _7x7: 1,
};

const PergolaPostSide = {
  FL: 0,
  FR: 1,
  RL: 2,
  RR: 3,

  FC: 4,
  BC: 5,
  LC: 6,
  RC: 7,

  CC: 8,
};

const PergolaElementOrientSide = {
  Front: 0,
  Back: 1,
  Left: 2,
  Right: 3,
  Center: 4,
};

// Клас для кольору
class PergolaColorElement {
  constructor() {
    this.name = "Espresso";
    this.select = null;
    this.colors = [];
  }
}

// Клас для даху
class PergolaRoof {
  constructor() {
    this.name = "";
    this.frames = [];
    this.beamFrames = [];
    this.beams = [];
    this.moodLights = [];
  }
}

class PergolaRoofFrame {
  constructor() {
    this.type = null;
    this.object = null;
    this.active = false;
  }
}

class PergolaRoofBeam {
  constructor() {
    this.type = null;
    this.direction = null;
    this.object = null;
    this.active = false;
  }
}

const PergolaRoofType = {
  Louvered: 0,
};

// Типи даху
class PergolaRoofTypeLouvered {
  constructor() {
    this.rotate = 0;
    this.rails = [];
    this.objects = [];
    // this.makeRoofOverhang = false;
  }
}

class PergolaRoofTypeLouveredObject {
  constructor() {
    this.object = null;
    this.active = false;
  }
}

// Константи напрямку даху
const PergolaRoofDirection = {
  Straight: 0,
  Perpendicular: 1,
};

// Клас для стін кріплення
class PergolaMountingWall {
  constructor() {
    this.elements = [];
  }
}

class PergolaMountingWallElement {
  constructor() {
    this.side = null;
    this.object = null;
    this.active = false;
  }
}

// Клас для додаткових опцій
class PergolaExtraOptions {
  constructor() {
    this.elements = [];
  }
}

// Клас для додаткових елементів
class PergolaExtraOptionElement {
  constructor() {
    this.type = null;
    this.active = false;
    this.object = null;
    this.objects = [];
  }
}

const PergolaExtraOptionType = {
  light: 0,
  fan: 1,
  heater: 2,
  led: 3,
  moodLight: 4,
  moodLed: 5,
};

var pergolaSettings = new PergolaSettings();

pergolaSettings.beamThickness = 0.0508;
pergolaSettings.postWidthInterval = 30;
pergolaSettings.postLengthInterval = 30;
pergolaSettings.beamWidthInterval = 20.1;
pergolaSettings.beamLengthInterval = 14.1;
pergolaSettings.beamPerimeterInterval = 20.1;
pergolaSettings.beamLouverLengthInterval = 14.1;

pergolaSettings.width = 18; // 18
pergolaSettings.length = 12; // 12
pergolaSettings.height = 8; // 8
pergolaSettings.postSize = PergolaPostType._7x7;
pergolaSettings.colorHex = "#281F1E";
pergolaSettings.colorLouveredHex = "#281F1E";
pergolaSettings.colorLedHex = "#FFFFFF";
pergolaSettings.colorMoodHex = "#FFFFFF";
pergolaSettings.roofType = PergolaRoofType.Louvered;
pergolaSettings.roofLouveredDirection = PergolaRoofDirection.Perpendicular;
pergolaSettings.roofLouveredRotate = 0;
pergolaSettings.mountingWall_Back = false;
pergolaSettings.mountingWall_Left = false;
pergolaSettings.mountingWall_Right = false;
pergolaSettings.extraOptionLight = false;
pergolaSettings.extraOptionLightSpacing = 4;
pergolaSettings.extraOptionFan = false;
pergolaSettings.extraOptionLed = false;
pergolaSettings.extraOptionHeaters = false;
pergolaSettings.extraOptionMoodLight = false;

var sceneTime = "Day"; // Day, Night
var blockURLWriter = true;
export var pergola = new PergolaObject();

function CreatePergola(model) {
  pergola = new PergolaObject(pergolaSettings);
  pergola.createFrom3DModel(model);
  changeSceneTime(sceneTime);
  AssignUIFromPergolaSettings();
}

//#region Assign UI

function AssignUIFromPergolaSettings() {
  if (pergolaSettings == null) {
    return;
  }

  $("#range-width").val(pergolaSettings.width);
  $("#range-width").trigger("change");

  $("#range-length").val(pergolaSettings.length);
  $("#range-length").trigger("change");

  $("#range-height").val(pergolaSettings.height);
  $("#range-height").trigger("change");

  switch (pergolaSettings.postSize) {
    case PergolaPostType._4x4:
      $("#postSize4").click();
      break;
    case PergolaPostType._7x7:
      $("#postSize7").click();
      break;
    default:
      $("#postSize7").click();
      break;
  }

  $("#color-frame").val(pergolaSettings.colorHex);
  $("#color-frame")
    .next(".color-picker-display")
    .css("background-color", pergolaSettings.colorHex);
  $("#group_1_title").text(pergolaSettings.colorHex);

  $("#color-louver").val(pergolaSettings.colorLouveredHex);
  $("#color-louver")
    .next(".color-picker-display")
    .css("background-color", pergolaSettings.colorLouveredHex);
  $("#group_2_title").text(pergolaSettings.colorLouveredHex);

  $("#color-led-lights").val(pergolaSettings.colorLedHex);
  $("#color-led-lights")
    .next(".color-picker-display")
    .css("background-color", pergolaSettings.colorLedHex);
  // $("#group_2_title").text(pergolaSettings.colorLedHex);

  $("#color-mood-lightning").val(pergolaSettings.colorMoodHex);
  $("#color-mood-lightning")
    .next(".color-picker-display")
    .css("background-color", pergolaSettings.colorMoodHex);
  // $("#group_2_title").text(pergolaSettings.colorMoodHex);

  $("#range-angle").val(pergolaSettings.roofLouveredRotate);
  $("#range-angle").trigger("change");

  $("#wallBack").prop("checked", pergolaSettings.mountingWall_Back);
  $("#wallBack").trigger("change");
  $("#wallLeft").prop("checked", pergolaSettings.mountingWall_Left);
  $("#wallLeft").trigger("change");
  $("#wallRight").prop("checked", pergolaSettings.mountingWall_Right);
  $("#wallRight").trigger("change");

  $("#moodLightning").prop("checked", pergolaSettings.extraOptionMoodLight);
  $("#moodLightning").trigger("change");
  $("#ledLights").prop("checked", pergolaSettings.extraOptionLed);
  $("#ledLights").trigger("change");
  $("#ceilingFan").prop("checked", pergolaSettings.extraOptionFan);
  $("#ceilingFan").trigger("change");
  $("#heaters").prop("checked", pergolaSettings.extraOptionHeaters);
  $("#heaters").trigger("change");
  $("#recessedLighting").prop("checked", pergolaSettings.extraOptionLight);
  $("#recessedLighting").trigger("change");

  $("#range-quantity").val(pergolaSettings.extraOptionLightSpacing);
  $("#range-quantity").trigger("change");

  if (sceneTime == "Night") {
    $(".tumbler-wrapper").addClass("active");
    changeSceneTime("Night");
  }

  // $('.formWrapper input[type="range"]').each(function() {
  //   updateRangeBackgroundAndLabel($(this));
  // });
}

function AssignUI() {
  qrcode = $("#qrcode");
  $(".hidden").hide();

  const gui_Dimensions_function = (dimensionType, value) => {
    if (pergolaSettings[dimensionType]) {
      pergolaSettings[dimensionType] = value;
      pergola.update();
    }
  };

  $("#range-width").on("input", function () {
    const newValue = $(this).val();
    if (pergolaSettings.width == newValue) {
      return;
    }
    gui_Dimensions_function("width", newValue);
  });

  $("#range-length").on("input", function () {
    const newValue = $(this).val();
    if (pergolaSettings.length == newValue) {
      return;
    }
    gui_Dimensions_function("length", newValue);
  });

  $("#range-height").on("input", function () {
    const newValue = $(this).val();
    if (pergolaSettings.height == newValue) {
      return;
    }
    gui_Dimensions_function("height", newValue);
  });

  const gui_PostSize_function = (postType) => {
    pergolaSettings.postSize = PergolaPostType[postType];
    pergola.update();
  };

  $("#postSize4").on("click", function () {
    gui_PostSize_function("_4x4");
  });
  $("#postSize7").on("click", function () {
    gui_PostSize_function("_7x7");
  });

  $("#color-frame").on("input", function () {
    pergolaSettings.colorHex = $(this).val();
    pergola.update();
  });

  $("#color-louver").on("input", function () {
    pergolaSettings.colorLouveredHex = $(this).val();
    pergola.update();
  });

  $("#color-led-lights").on("input", function () {
    pergolaSettings.colorLedHex = $(this).val();
    pergola.update();
  });

  $("#color-mood-lightning").on("input", function () {
    pergolaSettings.colorMoodHex = $(this).val();
    pergola.update();
  });

  $("#range-angle").on("input", function () {
    const newValue = ($(this).val() * 170) / 180;
    if (pergolaSettings.roofLouveredRotate == newValue) {
      return;
    }

    pergolaSettings.roofLouveredRotate = newValue;
    pergola.update();
  });

  $("#wallBack").on("click", function () {
    pergolaSettings.mountingWall_Back = !pergolaSettings.mountingWall_Back;
    pergola.update();
  });

  $("#wallLeft").on("click", function () {
    pergolaSettings.mountingWall_Left = !pergolaSettings.mountingWall_Left;
    pergola.update();
  });

  $("#wallRight").on("click", function () {
    pergolaSettings.mountingWall_Right = !pergolaSettings.mountingWall_Right;
    pergola.update();
  });

  $("#moodLightning").on("change", function () {
    pergolaSettings.extraOptionMoodLight = this.checked;
    pergola.update();
  });

  $("#ledLights").on("change", function () {
    pergolaSettings.extraOptionLed = this.checked;
    pergola.update();
  });

  $("#ceilingFan").on("change", function () {
    pergolaSettings.extraOptionFan = this.checked;
    isAutoRotate = this.checked;
    pergola.update();
  });

  $("#heaters").on("change", function () {
    pergolaSettings.extraOptionHeaters = this.checked;
    pergola.update();
  });

  $("#recessedLighting").on("change", function () {
    pergolaSettings.extraOptionLight = this.checked;
    pergola.update();
  });

  $("#range-quantity").on("input", function () {
    const newValue = $(this).val();
    if (pergolaSettings.extraOptionLightSpacing == newValue) {
      return;
    }

    pergolaSettings.extraOptionLightSpacing = newValue;
    pergola.update();
  });

  $("#js-summary").on("click", function () {
    CreateImageList();
    writeSummatyUI();
  });

  $(".tumbler-wrapper").on("click", function () {
    $(this).toggleClass("active");
    changeSceneTime($(this).hasClass("active") ? "Night" : "Day");
  });

  $("#js-showModalQRcode").on("click", function () {
    // OpenARorQR();
    PergolaOpenARorQR()
  });

  $("#js-showModalShare").on("click", function () {
    var data_url = GetURLWithParameters();

    if (wix_current_url != null) {
      data_url = wix_current_url;
    }

    var element = $("#info-sharing-input");
    element.val(data_url);
  });

  $("#js-showRequestEstimationModal").on("click", function () {
    wix_contactForm_Text = estimationStringValue();
    window.parent.postMessage(
      "WIX_ContactForm_Text|" + wix_contactForm_Text,
      "*"
    );
  });

  $("#share_copyToClipboard").on("click", function () {
    var data_url = GetURLWithParameters();
    if (wix_current_url != null) {
      data_url = wix_current_url;
    }

    console.log('Current state.electro:', state.electro);
    console.log('Electro size:', state.electro.size);
    console.log('Electro values:', [...state.electro.values()]);

    window.parent.postMessage("WIX_URL_CopyToClipboard|", "*");
    return;
  });

  // eslint-disable-next-line no-unused-vars
  $("#modalAR").on("dialogopen", function (event, ui) {
    qrScaned = 1;
    WriteURLParameters();
  });

  // eslint-disable-next-line no-unused-vars
  $("#modalAR").on("dialogclose", function (event, ui) {
    qrScaned = 0;
    WriteURLParameters();
  });
}

function estimationStringValue() {
  var result = "";
  var values = pergolaSettings.getValues();

  result += "I'd like to get a quotation for this configuration ";

  var data_url = GetURLWithParameters();
  if (wix_current_url != null) {
    data_url = wix_current_url;
  }

  result += data_url + "\n\n";

  switch (pergolaSettings.roofType) {
    case PergolaRoofType.Solid:
      values[4].options = null;
      break;
    case PergolaRoofType.Lattice:
      values[4].options = null;
      break;
    case PergolaRoofType.Louvered:
      values[4].options = null;
      break;
    default:
      values[4].options = null;
      break;
  }

  for (let index = 0; index < values.length; index++) {
    const element = values[index];
    result += element.name + ": ";

    if (element.options != null) {
      result += element.value + "\n";

      for (let i = 0; i < element.options.length; i++) {
        const arrayValue = element.options[i];
        result += arrayValue[0] + ": " + arrayValue[1] + "\n";
      }
    } else {
      result += element.value + "\n";
    }
  }

  return result;
}

function writeSummatyUI() {
  var values = [
    pergolaSettings.toString_dimensions(),
    pergolaSettings.toString_color(),
    pergolaSettings.toString_louverColor(),
    pergolaSettings.toString_postSize(),
    pergolaSettings.toString_mountingWall(),
    pergolaSettings.toString_extraOptions_Light(),
    pergolaSettings.toString_extraOptions_Led(),
    pergolaSettings.toString_extraOptions_Mood(),
    pergolaSettings.toString_extraOptions_Fan(),
    pergolaSettings.toString_extraOptions_Heater(),
  ];

  const itemValues = $(".summary__item_value");
  const subitemValues = $(".summary__subitem_value");
  let subItemIndex = 0;

  for (let i = 0; i < itemValues.length; i++) {
    $(itemValues[i]).text(values[i]);
    subItemIndex = i + 1;
  }

  for (let i = 0; i < subitemValues.length; i++) {
    $(subitemValues[i]).text(values[subItemIndex + i]);
  }
}
//#endregion

// GUI - TEST WORK
function customGUI() {
  const gui = new dat.GUI();
  gui.close();

  const gui_TimeOptions_functions = {
    default: false,
    Time: ["Day", "Night"],
  };
  gui.add(gui_TimeOptions_functions, "default");

  const folder_TimeOptions = gui.addFolder("Time Options");
  folder_TimeOptions
    .add(gui_TimeOptions_functions, "Time", gui_TimeOptions_functions.Time)
    .onChange(function (newValue) {
      changeSceneTime(newValue);
    });

  const gui_PDF_functions = {
    GetPDF: function () {
      // createPDF();
    },
  };

  const folder_PDF = gui.addFolder("PDF Options");
  folder_PDF.add(gui_PDF_functions, "GetPDF");

  const gui_CreateImage_functions = {
    CreateImages: function () {
      CreateImageList();
    },
  };

  const folder_Screenshot = gui.addFolder("Image Options");
  folder_Screenshot.add(gui_CreateImage_functions, "CreateImages");

  var params_Bloom = {
    threshold: 1,
    strength: 1,
    radius: 1,
  };

  const folder_bloom = gui.addFolder("Bloom Options");
  folder_bloom
    .add(params_Bloom, "threshold", 0, 10)
    .onChange(function (newValue) {
      updateBloomSettings(newValue);
    });
  folder_bloom
    .add(params_Bloom, "strength", 0, 10)
    .onChange(function (newValue) {
      updateBloomSettings(null, newValue);
    });
  folder_bloom.add(params_Bloom, "radius", 0, 10).onChange(function (newValue) {
    updateBloomSettings(null, null, newValue);
  });
}

//#endregion

export function changeSceneTime(value) {
  if (value == null) {
    return;
  }

  switch (value) {
    case "Night":
      updateEnvMap("./public/environment/moonless_golf_1k copy.hdr", 0.2, false);
      bloomPass.enabled = true;
      saoPass.enabled = true;
      outputPass.enabled = true;
      fxaaPass.enabled = true;
      scene.background = new THREE.Color(0x222222);
      dirLight.intensity = 0.03;
      frontLight.intensity = 0.05;
      leftLight.intensity = 0.05;
      rightLight.intensity = 0.05;
      updateBloomSettings(null, 0.45);
      changePointLightStatus(pointLights, 0.1, true);
      break;

    case "Day":
    default:
      bloomPass.enabled = false;
      saoPass.enabled = false;
      outputPass.enabled = false;
      fxaaPass.enabled = false;
      updateEnvMap(ENVIRONMENT_MAP, ENVIRONMENT_MAP_INTENSITY);
      updateBloomSettings(null, 0);
      scene.background = new THREE.Color(BACKGROUND_COLOR);
      changePointLightStatus(pointLights, 0, false);
      break;
  }

  sceneTime = value;
}

function changePointLightStatus(array, intensity, visible) {
  if (array == null) {
    return;
  }
  if (pointLights == null) {
    return;
  }
  if (pointLights.length <= 0) {
    return;
  }

  if (
    getMobileOperatingSystem() == "Android" ||
    getMobileOperatingSystem() == "iOS"
  ) {
    return;
  }

  if (pointLights.length > 0) {
    for (let index = 0; index < pointLights.length; index++) {
      const element = pointLights[index];
      element.intensity = intensity;
      element.visible = visible;
    }
  }
}

//#region PDF
function calculateImageScale(
  originalWidth,
  originalHeight,
  targetWidth,
  targetHeight
) {
  return Math.min(targetWidth / originalWidth, targetHeight / originalHeight);
}
// export async function createPDF() {
//   await CreateImageList();

//   const pdfDoc = await PDFDocument.create();

//   pdfDoc.registerFontkit(fontkit);
//   const font_regular_url = "./css/fonts/NeueHaasUnica-ExtraLight.ttf";
//   const font_bold_url = "./css/fonts/ITCAvantGardePro-Md.ttf";

//   const font_regular_bytes = await fetch(font_regular_url).then((res) =>
//     res.arrayBuffer()
//   );
//   const font_bold_bytes = await fetch(font_bold_url).then((res) =>
//     res.arrayBuffer()
//   );
//   const font_regular_value = await pdfDoc.embedFont(font_regular_bytes);
//   const font_bold_value = await pdfDoc.embedFont(font_bold_bytes);

//   const png_logo_url = "./src/pdf/logo.png";
//   const png_icon_web_url = "./src/pdf/icon_web.png";
//   const png_icon_phone_url = "./src/pdf/icon_phone.png";
//   const png_icon_email_url = "./src/pdf/icon_email.png";

//   var png_img_1_url = "./src/pdf/img_1.png";

//   if (share_RenderImages.length >= 1) {
//     png_img_1_url = share_RenderImages[0].src;
//   }


//   const png_logo_bytes = await fetch(png_logo_url).then((res) =>
//     res.arrayBuffer()
//   );
//   const png_icon_web_bytes = await fetch(png_icon_web_url).then((res) =>
//     res.arrayBuffer()
//   );
//   const png_icon_phone_bytes = await fetch(png_icon_phone_url).then((res) =>
//     res.arrayBuffer()
//   );
//   const png_icon_email_bytes = await fetch(png_icon_email_url).then((res) =>
//     res.arrayBuffer()
//   );

//   const png_img_1_bytes = await fetch(png_img_1_url).then((res) =>
//     res.arrayBuffer()
//   );

//   const png_logo_image = await pdfDoc.embedPng(png_logo_bytes);
//   const png_icon_web_image = await pdfDoc.embedPng(png_icon_web_bytes);
//   const png_icon_phone_image = await pdfDoc.embedPng(png_icon_phone_bytes);
//   const png_icon_email_image = await pdfDoc.embedPng(png_icon_email_bytes);

//   const png_img_1_image = await pdfDoc.embedPng(png_img_1_bytes);

//   const png_logo_dimensions = png_logo_image.scale(0.5);
//   const png_icon_web_dimensions = png_icon_web_image.scale(0.25);
//   const png_icon_phone_dimensions = png_icon_phone_image.scale(0.25);
//   const png_icon_email_dimensions = png_icon_email_image.scale(0.25);

//   if (state.leftWall) {
//     toggleLeftWall(false);
//   }
//   if (state.rightWall) {
//     toggleRightWall(false);
//   }
//   if (state.backWall) {
//     toggleBackWall(false);
//   }

//   const additionalImgScale = 0.6; // 1
//   const png_img_1_scale =
//     calculateImageScale(
//       png_img_1_image.width,
//       png_img_1_image.height,
//       share_RenderImageSize.x,
//       share_RenderImageSize.y
//     ) * additionalImgScale;

//   const png_img_1_dimensions = png_img_1_image.scale(png_img_1_scale);
//   const page1 = pdfDoc.addPage([595, 842]);

//   // HEADERS
//   // Page 1
//   page1.drawImage(png_logo_image, {
//     x: page1.getWidth() / 2 - png_logo_dimensions.width / 2,
//     y: page1.getHeight() - 30 - png_logo_dimensions.height,
//     width: png_logo_dimensions.width,
//     height: png_logo_dimensions.height,
//   });

//   // BOTTOM

//   // Page 1
//   const fontSizeBold = 12;

//   const elements = [
//     {
//       text: "(800) 401- 9323 ",
//       x: 50,
//       y: 33,
//       width: 73,
//       height: 13,
//       font: font_bold_value,
//       fontSize: fontSizeBold,
//       color: rgb(0.0, 0.0, 0.0),
//     },
//     {
//       text: "info@alumaluxusa.com",
//       x: 214,
//       y: 33,
//       width: 140,
//       height: 13,
//       font: font_bold_value,
//       fontSize: fontSizeBold,
//       color: rgb(0.0, 0.0, 0.0),
//     },
//     {
//       text: "www.alumaluxusa.com",
//       x: 427,
//       y: 33,
//       width: 140,
//       height: 13,
//       font: font_bold_value,
//       fontSize: fontSizeBold,
//       color: rgb(0.0, 0.0, 0.0),
//     },
//   ];

//   const icons = [
//     {
//       icon: png_icon_phone_image,
//       x: 30,
//       y: 30,
//       width: png_icon_phone_dimensions.width,
//       height: png_icon_phone_dimensions.height,
//     },
//     {
//       icon: png_icon_email_image,
//       x: 194,
//       y: 30,
//       width: png_icon_email_dimensions.width,
//       height: png_icon_email_dimensions.height,
//     },
//     {
//       icon: png_icon_web_image,
//       x: 409,
//       y: 30,
//       width: png_icon_web_dimensions.width,
//       height: png_icon_web_dimensions.height,
//     },
//   ];

//   elements.forEach(({ text, x, y, width, height, font, fontSize, color }) => {
//     page1.drawText(text, {
//       x,
//       y,
//       size: fontSize,
//       font: font,
//       color: color,
//     });
//   });

//   icons.forEach(({ icon, x, y, width, height }) => {
//     page1.drawImage(icon, {
//       x: x,
//       y: y,
//       width: width,
//       height: height,
//     });
//   });

//   // BODY

//   // Page 1
//   page1.drawImage(png_img_1_image, {
//     x: page1.getWidth() / 2 - png_img_1_dimensions.width / 2,
//     y:
//       page1.getHeight() -
//       30 -
//       png_img_1_dimensions.height -
//       png_logo_dimensions.height,
//     width: png_img_1_dimensions.width,
//     height: png_img_1_dimensions.height,
//   });

//   var values = pergolaSettings.getValues();
//   var indexValue = 0;
//   var indexHeigth = 0;
//   var indexHeigthAdditional = 0;

//   for (let index = 0; index < values.length; index++) {
//     const element = values[index];
//     indexHeigth =
//       page1.getHeight() -
//       png_logo_dimensions.height -
//       30 -
//       51 * (indexValue + 1) -
//       index -
//       png_img_1_dimensions.height -
//       indexHeigthAdditional;
//     page1.drawText(element.name, {
//       x: 30,
//       y: indexHeigth,
//       size: 14,
//       font: font_bold_value,
//       color: rgb(0.0, 0.0, 0.0),
//     });

//     if (element.options != null) {
//       page1.drawText(element.value, {
//         x:
//           page1.getWidth() -
//           30 -
//           font_regular_value.widthOfTextAtSize(element.value, 14),
//         y: indexHeigth,
//         size: 14,
//         font: font_regular_value,
//         color: rgb(0.0, 0.0, 0.0),
//       });
//       indexHeigthAdditional += 18;

//       for (let i = 0; i < element.options.length; i++) {
//         const arrayValue = element.options[i];

//         if (i === 0) {
//           indexHeigthAdditional += 24;
//         } else {
//           indexHeigthAdditional += 10;
//         }

//         indexHeigth =
//           page1.getHeight() -
//           png_logo_dimensions.height -
//           30 -
//           51 * (indexValue + 1) -
//           index -
//           png_img_1_dimensions.height -
//           indexHeigthAdditional;
//         page1.drawText(arrayValue[0], {
//           x: 30,
//           y: indexHeigth,
//           size: 14,
//           font: font_regular_value,
//           color: rgb(0.0, 0.0, 0.0),
//         });
//         page1.drawText(arrayValue[1], {
//           x:
//             page1.getWidth() -
//             30 -
//             font_regular_value.widthOfTextAtSize(arrayValue[1], 14),
//           y: indexHeigth,
//           size: 14,
//           font: font_regular_value,
//           color: rgb(0.0, 0.0, 0.0),
//         });

//         if (i != element.options.length - 1) {
//           indexHeigthAdditional += 14;
//         }
//       }
//     } else {
//       page1.drawText(element.value, {
//         x:
//           page1.getWidth() -
//           30 -
//           font_regular_value.widthOfTextAtSize(element.value, 14),
//         y: indexHeigth,
//         size: 14,
//         font: font_regular_value,
//         color: rgb(0.0, 0.0, 0.0),
//       });
//     }

//     indexValue += 1;

//     if (index == values.length - 1) {
//       continue;
//     }

//     page1.drawLine({
//       start: { x: 30, y: indexHeigth - 23 },
//       end: { x: page1.getWidth() - 30, y: indexHeigth - 23 },
//       thickness: 0.5,
//       color: rgb(0.573, 0.573, 0.573),
//     });
//   }

//   const pdfBytes = await pdfDoc.save();

//   const blob = new Blob([pdfBytes], { type: "application/pdf" });
//   const link = document.createElement("a");
//   link.href = URL.createObjectURL(blob);
//   link.download = "Hide-Away.pdf";
//   link.target = "_blank";
//   link.click();
// }

//#endregion

//#region Dimmensions

function removeObject3D(object3D) {
  if (!(object3D instanceof THREE.Object3D)) return false;

  if (object3D.geometry) object3D.geometry.dispose();

  if (object3D.material) {
    if (object3D.material instanceof Array) {
      object3D.material.forEach((material) => material.dispose());
    } else {
      object3D.material.dispose();
    }
  }
  object3D.removeFromParent();
  return true;
}

var dimmensionObjects = [];

let isDimensionRendering = false;

function changeDimmensionRender(status, lookAtCamera = null, stage) {
  if (!status) {
    for (let index = dimmensionObjects.length - 1; index >= 0; index--) {
      const element = dimmensionObjects[index];
      removeObject3D(element);
    }
    dimmensionObjects = [];
    return;
  }

  function getMeters(feet) {
    const meters = feet * 0.3048;
    return meters;
  }

  const {
    LB_point: FL_point,
    RB_point: FR_point,
    RT_point: RR_point,
  } = getCorners(state.width, state.length);
  const modelHeight = getMeters(state.height);
  const deltaHeight = 0.7;

  let textSize = 0.2;

  if (getMeters(state.width) > 15 || getMeters(state.length) > 15) {
    textSize = 0.25;
  }

  if (getMeters(state.width) > 25 || getMeters(state.length) > 25) {
    textSize = 0.3;
  }

  if (getMeters(state.width) > 30 || getMeters(state.length) > 30) {
    textSize = 0.35;
  }

  var pos_width_0 = new THREE.Vector3(
    FL_point.x - 0.1,
    modelHeight - deltaHeight,
    FL_point.z + 0.1
  );
  var pos_width_1 = new THREE.Vector3(
    FR_point.x + 0.08,
    modelHeight - deltaHeight,
    FR_point.z + 0.1
  );

  var pos_length_0 = new THREE.Vector3(
    FR_point.x + 0.1,
    modelHeight - deltaHeight,
    FR_point.z + 0.08
  );
  var pos_length_1 = new THREE.Vector3(
    RR_point.x + 0.1,
    modelHeight - deltaHeight,
    RR_point.z - 0.1
  );

  var pos_width_center = generateMidpoints(pos_width_0, pos_width_1, 1);
  var pos_length_center = generateMidpoints(pos_length_0, pos_length_1, 1);

  var pos_width_textPosition = new THREE.Vector3(
    pos_width_center[0].x,
    pos_width_center[0].y + 0.2,
    pos_width_center[0].z + 0.1
  );
  var pos_length_textPosition = new THREE.Vector3(
    pos_length_center[0].x + 0.1,
    pos_length_center[0].y + 0.1,
    pos_length_center[0].z
  );

  AddDimmension(
    pos_width_center[0],
    pos_width_0,
    pos_width_1,
    pergolaSettings.width.toString() + "'",
    pos_width_textPosition,
    "x",
    0.01,
    0x000000,
    lookAtCamera
  );
  createDimensionBorderLine(pos_width_0, 0.25, 0.01, "x", 0x000000);
  createDimensionBorderLine(pos_width_1, 0.25, 0.01, "x", 0x000000);
  createDimensionText(
    state.width.toString() + "'",
    pos_width_textPosition,
    0x000000,
    lookAtCamera,
    textSize
  );

  AddDimmension(
    pos_length_center[0],
    pos_length_0,
    pos_length_1,
    pergolaSettings.length.toString() + "'",
    pos_length_textPosition,
    "z",
    0.01,
    0x000000,
    lookAtCamera
  );
  createDimensionBorderLine(pos_length_0, 0.25, 0.01, "x", 0x000000);
  createDimensionBorderLine(pos_length_1, 0.25, 0.01, "x", 0x000000);
  createDimensionText(
    state.length.toString() + "'",
    pos_length_textPosition,
    0x000000,
    lookAtCamera,
    textSize
  );

  var pos_height_0 = new THREE.Vector3(RR_point.x + 0.5, -1, RR_point.z);
  var pos_height_1 = new THREE.Vector3(
    RR_point.x + 0.5,
    modelHeight - 1,
    RR_point.z
  );

  var pos_height_center = generateMidpoints(pos_height_0, pos_height_1, 1);
  var pos_height_textPosition = new THREE.Vector3(
    pos_height_center[0].x + 0.1,
    pos_height_center[0].y,
    pos_height_center[0].z
  );

  AddDimmension(
    pos_height_center[0],
    pos_height_0,
    pos_height_1,
    "8" + "'",
    pos_height_textPosition,
    "y",
    0.01,
    0x000000,
    lookAtCamera
  );
  createDimensionBorderLine(pos_height_0, 0.25, 0.01, "y", 0x000000);
  createDimensionBorderLine(pos_height_1, 0.25, 0.01, "y", 0x000000);
  createDimensionText(
    state.height.toString() + "'",
    pos_height_textPosition,
    0x000000,
    lookAtCamera,
    textSize
  );
}

function AddDimmension(
  position,
  start,
  end,
  text,
  textPosition = null,
  side = "x",
  thickness = 0.01,
  color = 0x000000,
  lookAtCamera = null
) {
  const line = createDimensionLine(
    position,
    start,
    end,
    thickness,
    side,
    color
  );
  scene.add(line);
  dimmensionObjects.push(line);

  /*
  if(textPosition != null){
    createDimensionText(text, textPosition, 0xF41818, lookAtCamera);
    return;
  }

  var line1_center = generateMidpoints(start, end, 1);
  createDimensionText(text, line1_center[0], 0xF41818, lookAtCamera);
  dimmensionObjects.push(line);
  */
}

function getDistance(point1, point2) {
  return point1.distanceTo(point2);
}

function createDimensionLine(
  position,
  start,
  end,
  thickness = 0.01,
  side = "x",
  color = 0x000000
) {
  //const material = new THREE.LineBasicMaterial({ color: color });
  var length = getDistance(start, end);

  var x_value = side != "x" ? thickness : length;
  var y_value = side != "y" ? thickness : length;
  var z_value = side != "z" ? thickness : length;

  const material = new THREE.MeshBasicMaterial({ color: color });
  const geometry = new THREE.BoxGeometry(x_value, y_value, z_value);
  const lineMesh = new THREE.Mesh(geometry, material);
  lineMesh.position.set(position.x, position.y, position.z);

  return lineMesh;
}

function createDimensionBorderLine(
  position,
  length,
  thickness = 0.01,
  side = "x",
  color = 0x000000
) {
  var x_value = side != "y" ? thickness : length;
  var y_value = side != "x" ? thickness : length;
  var z_value = side != "z" ? thickness : length;

  switch (side) {
    case "x":
      x_value = thickness;
      y_value = length;
      z_value = thickness;
      break;
    case "y":
      x_value = length;
      y_value = thickness;
      z_value = thickness;
      break;
    case "z":
      x_value = thickness;
      y_value = length;
      z_value = thickness;
      break;

    default:
      break;
  }

  const material = new THREE.MeshBasicMaterial({ color: color });
  const geometry = new THREE.BoxGeometry(x_value, y_value, z_value);
  const lineBorderMesh = new THREE.Mesh(geometry, material);
  lineBorderMesh.position.set(position.x, position.y, position.z);

  scene.add(lineBorderMesh);
  dimmensionObjects.push(lineBorderMesh);
  return lineBorderMesh;
}

function loadThreeJSFonts() {
  const loader = new FontLoader();
  loader.load(
    "https://threejs.org/examples/fonts/helvetiker_regular.typeface.json",
    function (font) {
      threejs_font_helvetiker_regular = font;
    }
  );
}

function createDimensionText(
  text,
  position,
  color = 0x000000,
  lookAtCamera = null,
  textSize = 0.2
) {
  if (threejs_font_helvetiker_regular == null) {
    return;
  }

  const textGeometry = new TextGeometry(text, {
    font: threejs_font_helvetiker_regular,
    size: textSize,
    depth: 0.01,
  });
  const textMaterial = new THREE.MeshBasicMaterial({ color: color });
  const textMesh = new THREE.Mesh(textGeometry, textMaterial);
  textMesh.position.set(position.x, position.y, position.z);

  if (lookAtCamera != null) {
    textMesh.lookAt(lookAtCamera.position);
  }

  scene.add(textMesh);
  dimmensionObjects.push(textMesh);

  return textMesh;
}

export function cleanupPDFDimensions() {
  changeDimmensionRender(false);
}

export { changeDimmensionRender, camera, share_RenderImages };
window.dimmensionObjects = dimmensionObjects;
export { dimmensionObjects };

//#endregion

//#region CAPTURE CAMERA IMAGE

var share_RenderImageSize = {
  x: 650,
  y: 350,
};

var share_RenderImages = [];

export async function CreateImageList() {
  if (canvas == null) {
    return;
  }

  const fov = 50;
  let width = Number(state.width);
  let length = Number(state.length);
  const sizeValue = width > length ? width : length;

  const deltaDist = ConvertMorphValue(state.height, 8, 15, 4.5, 8.0);
  const deltaY = ConvertMorphValue(state.height, 8, 15, 0.5, 2.0);
  const dist = (sizeValue / 40) * 10 + deltaDist;

  const cameraImageViews_Global = [
    {
      id: "view_1.png",
      alt: "view 1",
      cameraObject: new THREE.PerspectiveCamera(
        fov,
        canvas.width / canvas.height,
        0.01,
        1000
      ),
      position: new THREE.Vector3(dist / 1.7, 0 + deltaY, dist / 1.7),
      rotation: new THREE.Vector3(0, Math.PI / 4.25, 0),
    },
    // {
    //   id: "view_2.png",
    //   alt: "view 2",
    //   cameraObject: new THREE.PerspectiveCamera(fov, canvas.width / canvas.height, 0.01, 1000),
    //   position: new THREE.Vector3(0, dist, 0),
    //   rotation: new THREE.Vector3(-Math.PI / 2, 0, 0)
    // },
  ];

  share_RenderImages = [];

  // pergola.changeMountingWall(false, false, false, false);

  // //#region HIDE WALL
  // state.backWall = false;
  // state.leftWall = false;
  // state.rightWall = false;

  // const activeWallClass = "type_interface_checkbox-wall_item--active";
  // const backWall = $("#back");
  // const leftWall = $("#left");
  // const rightWall = $("#right");

  // function toggleClass(item, settings) {
  //   if (settings) {
  //     item.addClass(activeWallClass);
  //   } else {
  //     item.removeClass(activeWallClass);
  //   }
  // }

  // // INIT BUTTONS WALL
  // toggleBackWall(state.backWall);
  // toggleLeftWall(state.leftWall);
  // toggleRightWall(state.rightWall);

  // updateTextParam(state, backWall);

  // toggleClass(backWall, state.backWall);
  // toggleClass(leftWall, state.leftWall);
  // toggleClass(rightWall, state.rightWall);
  // //#endregion

  let old_sceneTime = sceneTime;
  changeSceneTime("Day");

  for (let index = 0; index < cameraImageViews_Global.length; index++) {
    const element = cameraImageViews_Global[index];
    element.cameraObject.visible = true;
    element.cameraObject.aspect = camera.aspect;
    element.cameraObject.updateProjectionMatrix();
    element.cameraObject.position.set(
      element.position.x,
      element.position.y,
      element.position.z
    );
    element.cameraObject.rotation.set(
      element.rotation.x,
      element.rotation.y,
      element.rotation.z
    );

    // changeDimmensionRender(true, element, index);
    TakeImage(element, "ar_pop_share_image");
    await new Promise((resolve) => setTimeout(resolve, 1));
    // changeDimmensionRender(false);
  }

  $("#js-summary-image-preview-1")
    .find("img")
    .attr("src", share_RenderImages[0].src);

  pdfImg.img = share_RenderImages[0].src;

  $("#js-summary-image-preview-1").find("img").eq(1).remove();

  changeSceneTime(old_sceneTime);
}

function TakeImage(view, img_class) {
  var img_div = document.createElement("div");
  img_div.classList.add(img_class);
  var img = CreateImage(view);
  img_div.appendChild(img);
  //DownloadRenderImage(img.src, img.alt);
  //ar_pop_share_pics.appendChild(img_div);
}

function CreateImage(view) {
  var img = new Image();

  renderer.setSize(share_RenderImageSize.x, share_RenderImageSize.y, false);
  view.cameraObject.aspect = share_RenderImageSize.x / share_RenderImageSize.y;
  view.cameraObject.updateProjectionMatrix();
  renderer.render(scene, view.cameraObject);

  img.src = renderer.domElement.toDataURL();
  img.alt = view.alt;

  share_RenderImages.push(img);

  view.cameraObject.visible = false;
  updateRenderSize();
  return img;
}

function DownloadRenderImage(src, alt) {
  if (src == null) {
    return;
  }
  if (alt == 0) {
    return;
  }

  var a = document.createElement("a");
  a.href = src;
  a.download = alt;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

//#endregion

//#region Encode/Decode

String.prototype.SEncode = function () {
  if (this == undefined) {
    return "";
  }
  return btoa(unescape(encodeURIComponent(this)));
};

String.prototype.SDecode = function () {
  if (this == undefined) {
    return "";
  }
  return decodeURIComponent(escape(atob(this)));
};

//#endregion

function rotateFans(fans, speed = 0.01) {
  if (isAutoRotate) {
    fans.forEach((obj) => {
      if (obj.active) {
        obj.object.rotation.y -= speed;
      }
    });
  }

  requestAnimationFrame(() => rotateFans(fans, speed));
}
